// import React, { useState, useEffect, useId } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
// // import "./createques.css";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
// import SelectedDropdownValues from "../CurateQuestionPaper/SelectedDropdownValues";
// import { fetchClassData } from "../../../Redux/StudentRegistration/classSlice";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import NotesIcon from "./../../../Assets/Images/CommanImages/grommet-icons_notes.png";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import ErrorIcon from "./../../../Assets/Images/CommanImages/Error.png";
// import SuccessImg from "./../../../Assets/Images/CommanImages/Informative.png";
// import MultiSeledDropdown from "../MultiDropdown/MultiSeledDropdown";
// import MultiProgress from "../MultiProgressBar/MultiProgress";
// import { fetchScopeData } from "../../../Redux/Scope/ScopeSlice";
// import { API_BASE_URL } from "../../../Config/Config";
// import FacultySelectorPreselected from "./FacultySelectorPreselected";
// import MultiSelectSearchDropdown from "../SearchDropDown/MultiSelectSearchDropdown";
// import EndPoints from "../../../Api/Endpoints";
// import { POST, GET } from "../../../Api/HttpsMethods";

// function CurateQuestionPaperEdit({
//   dataClient,
//   setMessageBox,
//   messageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   setNoTimeSet,
// }) {
//   const [questionPaperType, setQuestionPaperType] = useState(null);
//   const [selectedtestSeriesId, setSelectedTestSeriesID] = useState(1);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [searchParams] = useSearchParams();
//   const quesPaperIdFromURL = searchParams.get("MNTQuestionPaperID");
//   const [readOnlyMode, setReadOnlyMode] = useState(true);
//   const { coursesdata = [] } = useSelector((state) => state.course) || {};
//   const { classData = [] } = useSelector((state) => state.classname) || {};
//   const { scopeData = [] } = useSelector((state) => state.scopes) || {};
//   const [selectedCourse, setSelectedCourse] = useState(null);
//   const [selectedClass, setSelectedClass] = useState([]);
//   const [subjects, setSubjects] = useState([]);
//   const [expandedSubjects, setExpandedSubjects] = useState({});
//   const [chapterData, setChapterData] = useState({});
//   const [checkedSubjects, setCheckedSubjects] = useState({});
//   const [isOpen, setIsOpen] = useState(true);
//   const [isOpenSubject, setIsOpenSubject] = useState(true);
//   const [totalQuestionCount, setTotalQuestionCount] = useState(0);
//   const [QuestionTypeId, setQuestionTypeID] = useState(null);
//   const [selectedChapters, setSelectedChapters] = useState({});
//   const [difficultyDistributions, setDifficultyDistributions] = useState({});
//   const [selectScope, setSelectedScope] = useState(null);
//   const [openNotes, setOpenNotes] = useState({});
//   const [batchData, setBatchData] = useState([]);
//   const [selectedBatch, setSelectedBatch] = useState([]);
//   const [selectedCities, setSelectedCities] = useState([]);
//   const [cityData, setCityData] = useState([]);
//   const [selectedStates, setSelectedStates] = useState([]); // State selection
//   const [stateData, setStateData] = useState([]);
//   const [selectedBranch, setSelectedBranch] = useState([]);
//   const [selectedZone, setSelectedZone] = useState([]);
//   const [selectedRegion, setSelectedRegion] = useState([]);
//   const [branchData, setBranchData] = useState([]);
//   const [zoneData, setZoneData] = useState([]);
//   const [selectedFaculties, setSelectedFaculties] = useState([]);
//   const [selectedAssigReviewerFaculties, setSelectedAssigReviewerFaculties] = useState([]);
//   const [selectedCreatorsBySubject, setSelectedCreatorsBySubject] = useState( {} );
//   const [selectedReviewersBySubject, setSelectedReviewersBySubject] = useState( {} );
//   const [dropdownKey, setDropdownKey] = useState(0);
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
//   const userId = dataClient && dataClient.client_schema_name[6][0].user_id;
//   const [specialInstructions, setSpecialInstructions] = useState({});
//   const [patternsData, setPatternsData] = useState([]);
//   const [selectedPatternDetails, setSelectedPatternDetails] = useState(null);
//   const [selectedPattern, setSelectedPattern] = useState(null);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [testSeriesOptions, setTestSeriesOptions] = useState([]);
//   const [testSeriesData, setTestSeriesData] = useState([]);
//   const [manuallyUpdatedSubjects, setManuallyUpdatedSubjects] = useState({});
//   const accessToken = localStorage.getItem("other");
//   const [canEdit, setCanEdit] = useState(true);


//   useEffect(() => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       client_branch_id: clientBranchId,
//       created_by: userName,
//     }));
//   }, [clientBranchId, userName]);

//   useEffect(() => {
//     dispatch(fetchClassData());
//     dispatch(fetchCourseData());
//     dispatch(fetchScopeData());
//   }, [dispatch]);

//   useEffect(() => {
//     const fetchSubjectsByCourse = async () => {
//       if (!selectedCourse) {
//         setSubjects([]);
//         return;
//       }
//       try {
//         const API_ENDPOINT = `${EndPoints.PRISM_GET_SUBJECTS_BY_COURSE}?course_id=${selectedCourse}`;
//         const data = await GET.withToken(API_ENDPOINT);

//         setSubjects(Array.isArray(data) ? data : []);
//       } catch (error) {
//         console.error("Error fetching subjects:", error);
//         setSubjects([]);
//       }
//     };
//     fetchSubjectsByCourse();
//   }, [selectedCourse]);


//   const handleSubjectCheck = async (subjectId) => {
//     let shouldFetchChapters = false;

//     setCheckedSubjects((prev) => {
//       const isChecked = !prev[subjectId];
//       const chapters = chapterData[subjectId] || [];

//       if (isChecked) {
//         setSelectedChapters((prevChapters) => ({
//           ...prevChapters,
//           [subjectId]: chapters.map((ch) => ch.chapter_id),
//         }));

//         setFormData((prevFormData) => ({
//           ...prevFormData,
//           subjects: [
//             ...prevFormData.subjects.filter(
//               (s) => s.subject_id !== subjectId
//             ),
//             {
//               subject_id: subjectId,
//               easy: 0,
//               medium: 0,
//               tough: 0,
//               special_inst: "",
//               chapters: chapters.map((ch) => ({
//                 chapter_id: ch.chapter_id,
//               })),
//             },
//           ],
//         }));
//       } else {
//         setSelectedChapters((prevChapters) => ({
//           ...prevChapters,
//           [subjectId]: [],
//         }));

//         setFormData((prevFormData) => ({
//           ...prevFormData,
//           subjects: prevFormData.subjects.filter(
//             (s) => s.subject_id !== subjectId
//           ),
//         }));
//       }

//       if (!chapterData[subjectId]) {
//         shouldFetchChapters = true;
//       }

//       return { ...prev, [subjectId]: isChecked };
//     });

//     if (!shouldFetchChapters) return;

//     try {
//       const API_ENDPOINT = `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_id=${subjectId}`;
//       const data = await GET.withToken(API_ENDPOINT);

//       const chapters = Array.isArray(data) ? data : [];

//       setChapterData((prev) => ({
//         ...prev,
//         [subjectId]: chapters,
//       }));

//       setSelectedChapters((prevChapters) => ({
//         ...prevChapters,
//         [subjectId]: chapters.map((ch) => ch.chapter_id),
//       }));

//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         subjects: [
//           ...prevFormData.subjects.filter(
//             (s) => s.subject_id !== subjectId
//           ),
//           {
//             subject_id: subjectId,
//             easy: 0,
//             medium: 0,
//             tough: 0,
//             special_inst: "",
//             chapters: chapters.map((ch) => ({
//               chapter_id: ch.chapter_id,
//             })),
//           },
//         ],
//       }));
//     } catch (error) {
//       console.error("Error fetching chapters:", error);
//     }
//   };

//   const toggleExpandSubject = async (subjectId) => {
//     if (!checkedSubjects[subjectId]) return;

//     setExpandedSubjects((prev) => ({
//       ...prev,
//       [subjectId]: !prev[subjectId],
//     }));

//     if (chapterData[subjectId]) return;

//     try {
//       const API_ENDPOINT = `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_id=${subjectId}`;
//       const data = await GET.withToken(API_ENDPOINT);

//       const chapters = Array.isArray(data) ? data : [];

//       setChapterData((prev) => ({
//         ...prev,
//         [subjectId]: chapters,
//       }));

//       setSelectedChapters((prevChapters) => ({
//         ...prevChapters,
//         [subjectId]: chapters.map((ch) => ch.chapter_id),
//       }));
//     } catch (error) {
//       console.error("Error fetching chapters:", error);
//     }
//   };


//   const handleChapterCheck = (subjectId, chapterId) => {
//     setSelectedChapters((prevChapters) => {
//       const isSelected = prevChapters[subjectId]?.includes(chapterId);
//       const updatedChapters = isSelected
//         ? prevChapters[subjectId].filter((id) => id !== chapterId)
//         : [...(prevChapters[subjectId] || []), chapterId];
//       return { ...prevChapters, [subjectId]: updatedChapters };
//     });
//   };

//   const handleSelectAllChapters = (subjectId) => {
//     const allSelected =
//       selectedChapters[subjectId]?.length === chapterData[subjectId]?.length;

//     const updatedChapters = allSelected
//       ? []
//       : chapterData[subjectId].map((ch) => ch.chapter_id);

//     setSelectedChapters((prevChapters) => ({
//       ...prevChapters,
//       [subjectId]: updatedChapters,
//     }));

//     setCheckedSubjects((prev) => ({
//       ...prev,
//       [subjectId]: !allSelected, 
//     }));

//     setFormData((prevFormData) => {
//       const filteredSubjects = prevFormData.subjects.filter(
//         (s) => s.subject_id !== subjectId
//       );

//       if (allSelected) {
//         return {
//           ...prevFormData,
//           subjects: filteredSubjects,
//         };
//       } else {
//         return {
//           ...prevFormData,
//           subjects: [
//             ...filteredSubjects,
//             {
//               subject_id: subjectId,
//               easy: difficultyDistributions[subjectId]?.firstSegment || 0,
//               medium: difficultyDistributions[subjectId]?.secondSegment || 0,
//               tough: difficultyDistributions[subjectId]?.calculatedValue || 0,
//               special_inst: specialInstructions[subjectId] || "",
//               chapters: updatedChapters.map((id) => ({ chapter_id: id })),
//             },
//           ],
//         };
//       }
//     });
//   };

//   const toggleAccordion = () => {
//     setIsOpen(!isOpen);
//   };

//   const toggleAccordionSubjects = () => {
//     setIsOpenSubject(!isOpenSubject);
//   };

//   const handleQuestionCountChange = (subjectId, value) => {
//     if (/^\d*$/.test(value)) {
//       const parsedValue = parseInt(value || 0, 10);

//       setManuallyUpdatedSubjects((prev) => ({
//         ...prev,
//         [subjectId]: true,
//       }));

//       setSubjects((prevSubjects) =>
//         prevSubjects.map((subject) =>
//           subject.subject_id === subjectId
//             ? { ...subject, questionCount: parsedValue }
//             : subject
//         )
//       );

//       const easy = Math.floor(parsedValue / 3);
//       const medium = Math.floor(parsedValue / 3);
//       const tough = parsedValue - (easy + medium);

//       const newDistribution = {
//         firstSegment: easy,
//         secondSegment: medium,
//         calculatedValue: tough,
//       };

//       setDifficultyDistributions((prev) => ({
//         ...prev,
//         [subjectId]: newDistribution,
//       }));

//       setFormData((prevFormData) => {
//         const updatedSubjects = prevFormData.subjects.map((subject) => {
//           if (subject.subject_id === subjectId) {
//             return {
//               ...subject,
//               easy,
//               medium,
//               tough,
//             };
//           }
//           return subject;
//         });

//         return {
//           ...prevFormData,
//           subjects: updatedSubjects,
//         };
//       });

//       const newTotal = subjects.reduce((acc, subject) => {
//         const count =
//           subject.subject_id === subjectId
//             ? parsedValue
//             : parseInt(subject.questionCount || 0, 10);
//         return acc + count;
//       }, 0);
//       setTotalQuestionCount(newTotal);
//     }
//   };

//   const handleSliderChange = (subjectId, values) => {
//     setDifficultyDistributions((prev) => ({
//       ...prev,
//       [subjectId]: values,
//     }));

//     setFormData((prevFormData) => {
//       const updatedSubjects = prevFormData.subjects.map((subject) => {
//         if (subject.subject_id === subjectId) {
//           return {
//             ...subject,
//             easy: values.firstSegment || 0,
//             medium: values.secondSegment || 0,
//             tough: values.calculatedValue || 0,
//           };
//         }
//         return subject;
//       });

//       return {
//         ...prevFormData,
//         subjects: updatedSubjects,
//       };
//     });
//   };

//   const toggleNotesInput = (subjectId) => {
//     if (!checkedSubjects[subjectId]) return; // Prevent opening if subject is not selected
//     setOpenNotes((prev) => ({
//       ...prev,
//       [subjectId]: !prev[subjectId],
//     }));

//     if (!specialInstructions[subjectId]) {
//       setSpecialInstructions((prev) => ({
//         ...prev,
//         [subjectId]: "",
//       }));
//     }
//   };

//   const [formData, setFormData] = useState({
//     ques_paper_name: "",
//     description: "",
//     ques_paper_type: QuestionTypeId,
//     course_id: selectedCourse,
//     ques_paper_series: selectedPattern,
//     due_date: "",
//     ques_paper_scope_id: selectScope,
//     test_series_id: selectedtestSeriesId,
//     scope_ref_id: null,
//     client_branch_id: clientBranchId,
//     created_by: userName,
//     status: 1,
//     guidelines: "",
//     classes: selectedClass,
//     subjects: [
//       {
//         subject_id: 0,
//         easy: 0,
//         medium: 0,
//         tough: 0,
//         special_inst: "",
//         chapters: [],
//       },
//     ],
//     assign_creators: [
//       {
//         subject_id: 0,
//         user_ids: selectedFaculties.map((faculty) => faculty.user_id),
//       },
//     ],
//     assign_reviewers: [
//       { subject_id: 0, user_id: selectedAssigReviewerFaculties.user_id },
//     ],
//   });

//   // Add this logic to updated the subjects with question counts on deployment 01/07/2025
//   useEffect(() => {
//     if (!subjects || subjects.length === 0) return;
//     if (!formData || !formData.subjects || formData.subjects.length === 0)
//       return;

//     const questionCounts = {};
//     for (const subj of formData.subjects) {
//       const count = (subj.easy || 0) + (subj.medium || 0) + (subj.tough || 0);
//       questionCounts[subj.subject_id] = count;
//     }

//     setSubjects((prev) =>
//       prev.map((s) => ({
//         ...s,
//         questionCount: questionCounts[s.subject_id] || 0,
//       }))
//     );
//   }, [subjects, formData]);

//   const handleSpecialInstructionChange = (subjectId, value) => {
//     setSpecialInstructions((prev) => ({
//       ...prev,
//       [subjectId]: value,
//     }));
//   };

//   useEffect(() => {
//     const fetchPatterns = async () => {
//       if (!selectedCourse) {
//         setPatternsData([]);
//         setSelectedPatternDetails(null);
//         setSelectedSubjects([]);
//         return;
//       }

//       try {
//         const API_ENDPOINT = `${EndPoints.PRISM_GET_PATTERN_DETAILS}?course_id=${selectedCourse}`;
//         const data = await GET.withToken(API_ENDPOINT);

//         if (
//           !data ||
//           !Array.isArray(data.question_papers) ||
//           data.question_papers.length === 0
//         ) {
//           setPatternsData([]);
//           setSelectedPatternDetails(null);
//           setSelectedSubjects([]);
//           return;
//         }

//         const formattedPatterns = data.question_papers.map((pattern) => ({
//           id: pattern.ques_paper_layout.ques_paper_layout_id,
//           label: `${pattern.ques_paper_layout.ques_paper_layout_name} - ${pattern.ques_paper_layout.ques_paper_layout_desc}`,
//           details: pattern.ques_paper_details,
//           subjects: pattern.subjects || [],
//         }));

//         setPatternsData(formattedPatterns);
//         setSelectedPatternDetails(formattedPatterns[0]?.details || null);
//         setSelectedSubjects(formattedPatterns[0]?.subjects || []);
//       } catch (error) {
//         console.error("Error fetching pattern details:", error);
//         setPatternsData([]);
//         setSelectedPatternDetails(null);
//         setSelectedSubjects([]);
//       }
//     };

//     fetchPatterns();
//   }, [selectedCourse]);

//   // useEffect(() => {
//   //   const fetchScopeDetails = async () => {
//   //     try {
//   //       const response = await fetch(
//   //         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-scopes-details-all/`,
//   //         {
//   //           method: "GET",
//   //           headers: {
//   //             Authorization: `Bearer ${accessToken}`,
//   //             "Content-Type": "application/json",
//   //           },
//   //         }
//   //       );

//   //       if (!response.ok) {
//   //         throw new Error(`HTTP error! Status: ${response.status}`);
//   //       }

//   //       const data = await response.json();

//   //       if (data.status === 200) {
//   //         const apiData = data.data;
//   //         const uniqueBatches = apiData.reduce((acc, item) => {
//   //           if (!acc.some((batch) => batch.id === item.batch_id)) {
//   //             acc.push({
//   //               label: `${item.batch_name} / ${item.course_name} / ${item.class_name}`,
//   //               id: item.batch_id,
//   //               course_id: item.course_id,
//   //               class_id: item.class_id,
//   //             });
//   //           }
//   //           return acc;
//   //         }, []);

//   //         const uniqueBranch = apiData.reduce((acc, item) => {
//   //           if (!acc.some((branch) => branch.id === item.branch_id)) {
//   //             acc.push({
//   //               label: `${item.branch_name} / ${item.branch_code} / ${item.zone_code}`,
//   //               id: item.branch_id,
//   //             });
//   //           }
//   //           return acc;
//   //         }, []);

//   //         const uniqueZone = apiData.reduce((acc, item) => {
//   //           if (!acc.some((zone) => zone.id === item.city_zone_id)) {
//   //             acc.push({
//   //               label: `${item.zone_name} / ${item.city_name}`,
//   //               id: item.city_zone_id,
//   //             });
//   //           }
//   //           return acc;
//   //         }, []);

//   //         const uniqueCities = apiData.reduce((acc, item) => {
//   //           if (!acc.some((city) => city.id === item.city_id)) {
//   //             acc.push({
//   //               label: `${item.city_name} / ${item.state_name}`,
//   //               id: item.city_id,
//   //             });
//   //           }
//   //           return acc;
//   //         }, []);

//   //         const uniqueStates = apiData.reduce((acc, item) => {
//   //           if (!acc.some((state) => state.id === item.state_id)) {
//   //             acc.push({
//   //               label: item.state_name,
//   //               id: item.state_id,
//   //             });
//   //           }
//   //           return acc;
//   //         }, []);

//   //         setBatchData(uniqueBatches);
//   //         setBranchData(uniqueBranch);
//   //         setZoneData(uniqueZone);
//   //         setCityData(uniqueCities);
//   //         setStateData(uniqueStates);
//   //       }
//   //     } catch (error) {
//   //       console.error("Error fetching data:", error);
//   //     }
//   //   };

//   //   fetchScopeDetails();
//   // }, []);

//   useEffect(() => {
//     if (!clientBranchId || !selectedCourse || questionPaperType !== 2) {
//       setTestSeriesOptions([]);
//       setTestSeriesData([]);
//       return;
//     }
//     const apiUrl = `${EndPoints.PRISM_GET_TEST_SERIES_LIST_BY_BRANCH}?client_branch_id=${clientBranchId}`;
//     const fetchTestSeries = async () => {
//       try {
//         const response = await fetch(apiUrl, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         });
//         const data = await response.json();

//         if (data?.status === 200 && Array.isArray(data.data)) {
//           const filtered = data.data.filter(
//             (item) => item.course_id === selectedCourse
//           );
//           const unique = Array.from(
//             new Map(filtered.map((ts) => [ts.ts_id, ts])).values()
//           );

//           const options = unique.map((item) => ({
//             id: item.ts_id,
//             label: item.ts_name,
//           }));

//           setTestSeriesOptions(options);
//           setTestSeriesData(unique); 
//         }
//       } catch (err) {
//         console.error("Test series fetch failed", err);
//       }
//     };
//     fetchTestSeries();
//   }, [clientBranchId, selectedCourse, questionPaperType]);

//   useEffect(() => {
//     if (!quesPaperIdFromURL) return;

//     const fetchQuesPaperDetails = async () => {
//       try {
//         const API_ENDPOINT =
//           `${EndPoints.PRISM_GET_CURATE_QUES_PAPER_DETAILS_BY_PAPER_ID}?ques_paper_id=${quesPaperIdFromURL}`;

//         const result = await GET.withToken(API_ENDPOINT);

//         if (result?.status !== 200 || !result.data) return;

//         const data = result.data;

//         setCanEdit(Boolean(data.edit));
//         setSelectedCourse(data.course_id);
//         setQuestionPaperType(data.ques_paper_type);
//         setSelectedClass(data.class_ids);
//         setSelectedTestSeriesID(data.test_series || null);

//         setFormData((prev) => ({
//           ...prev,
//           ques_paper_name: data.ques_paper_name,
//           description: data.description,
//           guidelines: data.guideline,
//           due_date: data.due_date,
//           ques_paper_type: data.ques_paper_type,
//           course_id: data.course_id,
//           classes: data.class_ids,
//           test_series_id: data.test_series || null,
//         }));

//         /* ---------- Scope detection ---------- */
//         let detectedScopeId = null;
//         let detectedScopeRefIds = [];

//         if (Array.isArray(data.scope_detail) && data.scope_detail.length > 0) {
//           const r0 = data.scope_detail[0];

//           if ("batch_id" in r0) {
//             detectedScopeId = 1;
//             detectedScopeRefIds = data.scope_detail.map((s) => s.batch_id);
//             setSelectedBatch(detectedScopeRefIds);
//           } else if ("branch_id" in r0) {
//             detectedScopeId = 2;
//             detectedScopeRefIds = data.scope_detail.map((s) => s.branch_id);
//             setSelectedBranch(detectedScopeRefIds);
//           } else if ("zone_id" in r0 || "city_zone_id" in r0) {
//             detectedScopeId = 3;
//             detectedScopeRefIds = data.scope_detail.map(
//               (s) => s.zone_id ?? s.city_zone_id
//             );
//             setSelectedZone(detectedScopeRefIds);
//           } else if ("city_id" in r0) {
//             detectedScopeId = 4;
//             detectedScopeRefIds = data.scope_detail.map((s) => s.city_id);
//             setSelectedCities(detectedScopeRefIds);
//           } else if ("state_id" in r0) {
//             detectedScopeId = 5;
//             detectedScopeRefIds = data.scope_detail.map((s) => s.state_id);
//             setSelectedStates(detectedScopeRefIds);
//           } else if ("region_id" in r0) {
//             detectedScopeId = 6;
//             detectedScopeRefIds = data.scope_detail.map((s) => s.region_id);
//             setSelectedRegion(detectedScopeRefIds);
//           }
//         }

//         setSelectedScope(detectedScopeId);
//         setFormData((prev) => ({
//           ...prev,
//           ques_paper_scope_id: detectedScopeId,
//           scope_ref_id: detectedScopeRefIds,
//         }));

//         /* ---------- Subjects ---------- */
//         const newCheckedSubjects = {};
//         const newDifficulty = {};
//         const newFormSubjects = [];
//         const questionCounts = {};
//         let totalQues = 0;

//         const chapterFetchPromises = [];

//         for (const subjectId of Object.keys(data.subject_info)) {
//           const info = data.subject_info[subjectId];
//           const sid = Number(subjectId);

//           newCheckedSubjects[sid] = true;
//           questionCounts[sid] = info.ques_count;
//           totalQues += info.ques_count;

//           newDifficulty[sid] = {
//             firstSegment: info.easy,
//             secondSegment: info.medium,
//             calculatedValue: info.tough,
//           };

//           setSelectedChapters((prev) => ({
//             ...prev,
//             [sid]: info.chapters || [],
//           }));

//           newFormSubjects.push({
//             subject_id: sid,
//             easy: info.easy,
//             medium: info.medium,
//             tough: info.tough,
//             special_inst: info.instructions || "",
//             chapters: (info.chapters || []).map((id) => ({
//               chapter_id: id,
//             })),
//           });

//           /* ---------- Creators ---------- */
//           setSelectedCreatorsBySubject((prev) => ({
//             ...prev,
//             [sid]: (info.creators || []).map((u) => {
//               const [lastName, firstMiddle = ""] = u.user_name.split(",");
//               const [firstName = "", middleName = ""] =
//                 firstMiddle.trim().split(" ");
//               return {
//                 user_id: u.user_id,
//                 emp_first_name: firstName,
//                 emp_middle_name: middleName,
//                 emp_last_name: lastName,
//               };
//             }),
//           }));

//           /* ---------- Reviewers ---------- */
//           setSelectedReviewersBySubject((prev) => ({
//             ...prev,
//             [sid]: (info.reviewers || []).map((u) => {
//               const [lastName, firstMiddle = ""] = u.user_name.split(",");
//               const [firstName = "", middleName = ""] =
//                 firstMiddle.trim().split(" ");
//               return {
//                 user_id: u.user_id,
//                 emp_first_name: firstName,
//                 emp_middle_name: middleName,
//                 emp_last_name: lastName,
//               };
//             }),
//           }));

//           /* ---------- Fetch chapters if missing ---------- */
//           if (!chapterData[sid]) {
//             chapterFetchPromises.push(
//               GET.withToken(
//                 `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_id=${sid}`
//               ).then((chapters) => {
//                 setChapterData((prev) => ({
//                   ...prev,
//                   [sid]: Array.isArray(chapters) ? chapters : [],
//                 }));
//               })
//             );
//           }
//         }

//         await Promise.all(chapterFetchPromises);

//         setCheckedSubjects(newCheckedSubjects);
//         setDifficultyDistributions(newDifficulty);
//         setTotalQuestionCount(totalQues);

//         setSubjects((prev) =>
//           prev.map((s) => ({
//             ...s,
//             questionCount: questionCounts[s.subject_id] || 0,
//           }))
//         );

//         setFormData((prev) => ({
//           ...prev,
//           subjects: newFormSubjects,
//         }));
//       } catch (err) {
//         console.error("Failed to fetch question paper details", err);
//       }
//     };

//     fetchQuesPaperDetails();
//   }, [quesPaperIdFromURL]);

//   const handleSaveEditedPaper = async () => {
//     let errorMessage = "";
//     // if (!formData.classes || formData.classes.length === 0) {
//     //   errorMessage = "At least one class must be selected.";
//     // } else
//     if (!formData.due_date) {
//       errorMessage = "Due Date is required.";
//     } else {
//       const dueDate = new Date(formData.due_date);
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);
//       dueDate.setHours(0, 0, 0, 0);
//       if (isNaN(dueDate.getTime())) {
//         errorMessage = "Please enter a valid due date.";
//       } else if (dueDate < today) {
//         errorMessage = "Due date cannot be in the past.";
//       }
//     }
//     const selectedSubjects = subjects.filter(
//       (subject) => checkedSubjects[subject.subject_id]
//     );
//     if (!errorMessage && selectedSubjects.length === 0) {
//       errorMessage = "At least one subject must be selected.";
//     }
//     const hasZeroQuestionCount = selectedSubjects.some(
//       (subject) => (parseInt(subject.questionCount, 10) || 0) === 0
//     );
//     if (!errorMessage && hasZeroQuestionCount) {
//       errorMessage = "Question count cannot be zero for any selected subject.";
//     }

//     //  Ensure question count is at least 3 for any selected subject
//     const hasLessThanThreeQuestions = selectedSubjects.some(
//       (subject) => {
//         const count = parseInt(subject.questionCount, 10) || 0;
//         return count > 0 && count < 3;
//       }
//     );
    
//     if (!errorMessage && hasLessThanThreeQuestions) {
//       errorMessage = "Question count must be at least 3 for each selected subject.";
//     }
    
//     const assignCreators = selectedSubjects.map((subject) => ({
//       subject_id: subject.subject_id,
//       user_ids: (selectedCreatorsBySubject[subject.subject_id] || []).map(
//         (faculty) => faculty.user_id
//       ),
//     }));

//     const hasSubjectWithoutCreator = assignCreators.some(
//       (subject) => subject.user_ids.length === 0
//     );
//     if (!errorMessage && hasSubjectWithoutCreator) {
//       errorMessage =
//         "Each selected subject must have at least one assigned creator.";
//     }
//     if (errorMessage) {
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{errorMessage}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorIcon);
//       return;
//     }
//     try {
//       const payload = {
//         class_ids: formData.classes || [],
//         test_series: formData.test_series_id || null,
//         ques_paper_name: formData.ques_paper_name || "",
//         due_date: formData.due_date || "",
//         ques_paper_scope_id: formData.ques_paper_scope_id || null,
//         scope_ref_id: Array.isArray(formData.scope_ref_id)
//           ? formData.scope_ref_id.filter((id) => typeof id === "number")
//           : [],
//         description: formData.description || "",
//         guideline: formData.guidelines || "",
//         subject_info: Object.entries(checkedSubjects)
//           .filter(([subjectId, checked]) => checked)
//           .map(([subjectId]) => {
//             const sid = parseInt(subjectId);
//             const difficulty = difficultyDistributions[sid] || {};
//             return {
//               subject_id: sid,
//               status: 1,
//               chapters: selectedChapters[sid] || [],
//               instructions: specialInstructions[sid] || "",
//               easy: difficulty.firstSegment || 0,
//               medium: difficulty.secondSegment || 0,
//               tough: difficulty.calculatedValue || 0,
//               creators: (selectedCreatorsBySubject[sid] || []).map(
//                 (f) => f.user_id
//               ),
//               reviewers: (selectedReviewersBySubject[sid] || []).map(
//                 (f) => f.user_id
//               ),
//             };
//           }),
//       };

//       const response = await fetch(
//        `${EndPoints.PRISM_UPDATE_CURATE_QUES_PAPER_DETAILS_BY_PAPER_ID}?ques_paper_id=${quesPaperIdFromURL}`,
//         {
//           method: "PUT",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       const result = await response.json();

//       if (response.ok && result.status === 200) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Question Paper updated successfully!</span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         // setReadOnlyMode(true);
//       } else {
//         throw new Error(result.message || "Failed to update question paper");
//       }
//     } catch (err) {
//       console.error("Error updating paper:", err);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{err.message || "Something went wrong while saving"}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorIcon);
//     }
//   };

//   const handleDeleteQuestionPaper = () => {
//     setNoTimeSet(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Do you want to delete this question paper?</span>
//         </div>
//         <div
//           className="messagebox-insider2"
//           style={{ display: "flex", gap: "10px", marginTop: "10px" }}
//         >
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={async () => {
//               // YES => Call API
//               setIsMessageBoxVisible(false);
//               try {
//                 const res = await fetch(
//                   `${EndPoints.PRISM_DELETE_CURATE_QUESTION_PAPER}?ques_paper_id=${quesPaperIdFromURL}&user_name=${userName}`,
//                   {
//                     method: "PUT",
//                     headers: {
//                       Authorization: `Bearer ${accessToken}`,
//                       Accept: "application/json",
//                     },
//                   }
//                 );
//                 const result = await res.json();
//                 if (result.status === 200) {
//                   setIsMessageBoxVisible(true);
//                   setMessageBox(
//                     <div className="Container-messageBOX">
//                       <div className="messagebox-insider1">
//                         <div className="loader-tc"></div>
//                         <span>Question Paper deleted successfully!</span>
//                       </div>
//                     </div>
//                   );
//                   setActiveImg(SuccessImg);
//                   // setIsMessageBoxVisible(false);
//                   setNoTimeSet(false);
//                   setTimeout(() => {
//                     navigate("/assignor_dashboard_details");
//                   }, 500);
//                 } else {
//                   throw new Error(result.message || "Delete failed");
//                 }
//               } catch (err) {
//                 setMessageBox(
//                   <div className="Container-messageBOX">
//                     <div className="messagebox-insider1">
//                       <div className="loader-tc"></div>
//                       <span>{err.message}</span>
//                     </div>
//                   </div>
//                 );
//                 setActiveImg(ErrorIcon);
//                 setIsMessageBoxVisible(true);
//               }
//             }}
//           >
//             YES
//           </button>
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={() => {
//               setIsMessageBoxVisible(false);
//               setNoTimeSet(false);
//             }}
//           >
//             NO
//           </button>
//         </div>
//       </div>
//     );
//     setActiveImg(InterogativeImg);
//     setIsMessageBoxVisible(true);
//   };

//   const isEditDisabled = questionPaperType === 1 && !canEdit; 
  
//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Curate Question Paper</span>
//         <div className="cr-header-btn-container">
//           <button
//             className="cr-cancel-btn"
//             onClick={() => navigate(`/assignor_dashboard_details`)}
//           >
//             CANCEL
//           </button>
//           {readOnlyMode ? (
//             <>
//               <button
//                 className="cr-create-btn"
//                 onClick={handleDeleteQuestionPaper}
//               >
//                 {" "}
//                 DELETE{" "}
//               </button>
//               {/* <button
//                 className="cr-create-btn"
//                 onClick={() => setReadOnlyMode(false)}
//               >
//                 {" "}
//                 EDIT{" "}
//               </button> */}

//               <button
//                 type="button"
//                 className="cr-create-btn"
//                 disabled={isEditDisabled}
//                 onClick={!isEditDisabled ? () => setReadOnlyMode(false) : undefined}
//                 style={{
//                   boxShadow: "0px 4px 4px 0px #00000040",
//                   backgroundColor: isEditDisabled ? "#d3d3d3" : "#ffffff",
//                   cursor: isEditDisabled ? "not-allowed" : "pointer",
//                   color: isEditDisabled ? "#888" : "#424342",
//                   // pointerEvents: isEditDisabled ? "none" : "auto", 
//                 }}
//                 onMouseEnter={(e) => {
//                   if (!isEditDisabled) {
//                     e.currentTarget.style.backgroundColor = "#fa4741";
//                     e.currentTarget.style.color = "white";
//                   }
//                 }}
//                 onMouseLeave={(e) => {
//                   if (!isEditDisabled) {
//                     e.currentTarget.style.backgroundColor = "#ffffff";
//                     e.currentTarget.style.color = "#424342";
//                   }
//                 }}
//               >
//                 EDIT
//               </button>
//             </>
//           ) : (
//             <button className="cr-create-btn" onClick={handleSaveEditedPaper}>
//               {" "}
//               SAVE{" "}
//             </button>
//           )}
//         </div>
//       </div>
//       {/* QUESTION PAPER DETAIL Section */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>QUESTION PAPER DETAIL</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionSubjects}>
//             {isOpenSubject ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>
//         {isOpenSubject && (
//           <div className="accordion-content">
//             <div className="select-assign-test-container-ques-pap-del">
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1">
//                   {/* RESET WHEN CHANGES THE COURSE */}
//                   <SelectedDropdownValues
//                     label="Course"
//                     selected={selectedCourse}
//                     setSelected={(selectedOption) => {
//                       // 1. Reset all dependent state
//                       setSelectedCourse(selectedOption || null);
//                       setSelectedClass([]);
//                       setSelectedScope(null);
//                       setSelectedBatch([]);
//                       setSelectedBranch([]);
//                       setSelectedZone([]);
//                       setSelectedCities([]);
//                       setSelectedStates([]);
//                       setSelectedRegion([]);
//                       setSubjects([]);
//                       setCheckedSubjects({});
//                       setExpandedSubjects({});
//                       setSelectedChapters({});
//                       setSpecialInstructions({});
//                       setSelectedTestSeriesID(null);
//                       setTestSeriesOptions([]);
//                       setTestSeriesData([]);
//                       setDifficultyDistributions({});
//                       setTotalQuestionCount(0);
//                       setSelectedCreatorsBySubject({});
//                       setSelectedReviewersBySubject({});
//                       setSelectedPattern(null);
//                       setSelectedPatternDetails(null);
//                       setSelectedSubjects([]);
//                       setFormData((prevFormData) => ({
//                         ...prevFormData,
//                         course_id: selectedOption || null,
//                         ques_paper_scope_id: null,
//                         scope_ref_id: null,
//                         classes: [],
//                         subjects: [],
//                         test_series_id: null,
//                         assign_creators: [],
//                         assign_reviewers: [],
//                       }));

//                       // 2. Clear dropdown re-render (if needed)
//                       setDropdownKey((prev) => prev + 1);
//                     }}
//                     options={
//                       Array.isArray(coursesdata)
//                         ? coursesdata.map((course) => ({
//                             label: course.course_name,
//                             id: course.course_id,
//                           }))
//                         : []
//                     }
//                     isRequired={true}
//                     disabled={true}
//                   />
//                 </div>
//                 <div className="item2">
//                   <SelectedDropdownValues
//                     label="Question Paper Type"
//                     selected={questionPaperType}
//                     setSelected={(selectedOption) => {
//                       setQuestionPaperType(selectedOption);
//                       if (selectedOption === 1) {
//                         setSelectedTestSeriesID(null);
//                         setDropdownKey((prev) => prev + 1); 
//                         setSelectedClass([]);
//                         setSelectedScope(null);
//                         setSelectedBatch([]);
//                         setSelectedBranch([]);
//                         setSelectedZone([]);
//                         setSelectedCities([]);
//                         setSelectedStates([]);
//                         setSelectedRegion([]);
//                         setCheckedSubjects({});
//                         setExpandedSubjects({});
//                         setSelectedChapters({});
//                         setSpecialInstructions({});
//                         setDifficultyDistributions({});
//                         setTotalQuestionCount(0);
//                         setSelectedCreatorsBySubject({});
//                         setSelectedReviewersBySubject({});
//                         setSelectedPattern(null);
//                         setSelectedPatternDetails(null);
//                         setSelectedSubjects([]);

//                         setFormData((prevFormData) => ({
//                           ...prevFormData,
//                           ques_paper_type: selectedOption,
//                           test_series_id: null,
//                           ques_paper_scope_id: null,
//                           scope_ref_id: null,
//                           classes: [],
//                           subjects: [],
//                           assign_creators: [],
//                           assign_reviewers: [],
//                         }));
//                       } else {
//                         // If "Test", just set type in formData
//                         setFormData((prev) => ({
//                           ...prev,
//                           ques_paper_type: selectedOption || null,
//                         }));
//                       }
//                     }}
//                     options={[
//                       { id: 1, label: "DPP" },
//                       { id: 2, label: "Test" },
//                     ]}
//                     isRequired={true}
//                     disabled={true}
//                   />
//                 </div>
//                 <div className="item2">
//                   <SelectedDropdownValues
//                     label="Test Series"
//                     key={dropdownKey}
//                     selected={selectedtestSeriesId}
//                     setSelected={(selectedOption) => {
//                       setSelectedTestSeriesID(selectedOption);
//                       setFormData((prev) => ({
//                         ...prev,
//                         test_series_id: selectedOption || null,
//                       }));
//                       // Find the selected test series object
//                       const tsObject = testSeriesOptions.find(
//                         (ts) => ts.id === selectedOption
//                       );
//                       // You need the full test series object from API response, so use:
//                       const fullTS = testSeriesData.find(
//                         (ts) => ts.ts_id === selectedOption
//                       );
//                       if (!fullTS) return;
//                       // ✅ Auto-select Class
//                       const classIds = fullTS.class_id_list || [];
//                       setSelectedClass(classIds);
//                       setFormData((prev) => ({ ...prev, classes: classIds }));
//                       // ✅ Auto-select Scope
//                       setSelectedScope(fullTS.scope_id);
//                       setFormData((prev) => ({
//                         ...prev,
//                         ques_paper_scope_id: fullTS.scope_id,
//                         // scope_ref_id: fullTS.scope_ref_ids || [],
//                         scope_ref_id: (fullTS.scope_ref_ids || []).map(
//                           (item) => item.id
//                         ),
//                       }));
//                       switch (fullTS.scope_id) {
//                         case 1:
//                           setSelectedBatch(
//                             (fullTS.scope_ref_ids || []).map((item) => item.id)
//                           );
//                           break;
//                         case 2:
//                           setSelectedBranch(
//                             (fullTS.scope_ref_ids || []).map((item) => item.id)
//                           );
//                           break;
//                         case 3:
//                           setSelectedZone(
//                             (fullTS.scope_ref_ids || []).map((item) => item.id)
//                           );
//                           break;
//                         case 4:
//                           setSelectedCities(
//                             (fullTS.scope_ref_ids || []).map((item) => item.id)
//                           );
//                           break;
//                         case 5:
//                           setSelectedStates(
//                             (fullTS.scope_ref_ids || []).map((item) => item.id)
//                           );
//                           break;
//                         case 6:
//                           setSelectedRegion(
//                             (fullTS.scope_ref_ids || []).map((item) => item.id)
//                           );
//                           break;
//                         default:
//                           break;
//                       }
//                       const checked = {};
//                       const questionCounts = {};
//                       const difficultyMap = {};
//                       const formSubjects = [];
//                       let totalCount = 0;
//                       const subjectMap = {};
//                       (fullTS.subject_section || []).forEach((subj) => {
//                         const subjectId = subj.subject_id;
//                         if (!subjectMap[subjectId]) {
//                           subjectMap[subjectId] = {
//                             subject_id: subjectId,
//                             total_question_cnt: 0,
//                             ms_desc: subj.ms_desc || "",
//                           };
//                         }
//                         subjectMap[subjectId].total_question_cnt +=
//                           subj.total_question_cnt || 0;
//                       });

//                       Object.values(subjectMap).forEach((subj) => {
//                         checked[subj.subject_id] = true;
//                         const count = subj.total_question_cnt || 0;
//                         questionCounts[subj.subject_id] = count;

//                         const easy = Math.floor(count / 3);
//                         const medium = Math.floor(count / 3);
//                         const tough = count - (easy + medium);
//                         difficultyMap[subj.subject_id] = {
//                           firstSegment: easy,
//                           secondSegment: medium,
//                           calculatedValue: tough,
//                         };
//                         totalCount += count;

//                         formSubjects.push({
//                           subject_id: subj.subject_id,
//                           easy,
//                           medium,
//                           tough,
//                           special_inst: subj.ms_desc || "",
//                           chapters: [],
//                         });
//                       });
//                       setCheckedSubjects(checked);
//                       setDifficultyDistributions(difficultyMap);
//                       setTotalQuestionCount(totalCount);
//                       setSubjects((prevSubjects) =>
//                         prevSubjects.map((s) => ({
//                           ...s,
//                           questionCount: questionCounts[s.subject_id] || 0,
//                         }))
//                       );
//                       setFormData((prev) => ({
//                         ...prev,
//                         subjects: formSubjects,
//                       }));
//                     }}
//                     options={testSeriesOptions}
//                     isRequired={false}
//                     disabled={questionPaperType === 1 || readOnlyMode}
//                   />
//                 </div>
//                 {/* <div className="item3">
//                   <MultiSeledDropdown
//                     label="Class"
//                     width="100%"
//                     selected={selectedClass}
//                     setSelected={(selected) => {
//                       setSelectedClass(selected);
//                       setFormData({ ...formData, classes: selected });
//                     }}
//                     options={
//                       Array.isArray(classData)
//                         ? classData.map((cls) => ({
//                             label: cls.class_name,
//                             id: cls.class_id,
//                           }))
//                         : []
//                     }
//                     showSelectAll={true}
//                     isRequired={true}
//                     disabled={readOnlyMode || !!selectedtestSeriesId}
//                   />
//                 </div> */}
//                 <div className="item4">
//                   <FormInputs
//                     label="Question Paper Name"
//                     value={formData.ques_paper_name}
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         ques_paper_name: e.target.value,
//                       })
//                     }
//                     required
//                     disabled={readOnlyMode}
//                   />
//                 </div>
//                 <div className="item6">
//                   <FormInputs
//                     label="Due Date"
//                     type="datetime-local"
//                     value={formData.due_date}
//                     onChange={(e) =>
//                       setFormData({ ...formData, due_date: e.target.value })
//                     }
//                     required
//                     disabled={readOnlyMode}
//                   />
//                 </div>
//                 {/* <div className="item7">
//                   <SelectedDropdownValues
//                     label="Scope"
//                     selected={selectScope}
//                     setSelected={(selectedOption) => {
//                       setSelectedScope(selectedOption || null);
//                       setFormData({
//                         ...formData,
//                         ques_paper_scope_id: selectedOption || null,
//                       });
//                     }}
//                     options={
//                       Array.isArray(scopeData)
//                         ? scopeData.map((scope) => ({
//                             label: scope.ques_paper_scope_desc,
//                             id: scope.ques_paper_scope_id,
//                           }))
//                         : []
//                     }
//                     disabled={readOnlyMode || !!selectedtestSeriesId}
//                   />
//                 </div> */}
//                 {/* <div className="item8">
//                   <MultiSelectSearchDropdown
//                     label={
//                       selectScope === 1
//                         ? "Batch"
//                         : selectScope === 2
//                         ? "Branch"
//                         : selectScope === 3
//                         ? "Zone"
//                         : selectScope === 4
//                         ? "City"
//                         : selectScope === 5
//                         ? "State"
//                         : selectScope === 6
//                         ? "Region"
//                         : selectScope === 7
//                         ? "No Scope"
//                         : "Select Scope"
//                     }
//                     width="100%"
//                     selected={
//                       selectScope === 1
//                         ? selectedBatch
//                         : selectScope === 2
//                         ? selectedBranch
//                         : selectScope === 3
//                         ? selectedZone
//                         : selectScope === 4
//                         ? selectedCities
//                         : selectScope === 5
//                         ? selectedStates
//                         : selectScope === 6
//                         ? selectedRegion
//                         : []
//                     }
//                     setSelected={(selectedOptions) => {
//                       if (selectScope === 1) {
//                         setSelectedBatch(selectedOptions);
//                       } else if (selectScope === 2) {
//                         setSelectedBranch(selectedOptions);
//                       } else if (selectScope === 3) {
//                         setSelectedZone(selectedOptions);
//                       } else if (selectScope === 4) {
//                         setSelectedCities(selectedOptions);
//                       } else if (selectScope === 5) {
//                         setSelectedStates(selectedOptions);
//                       } else if (selectScope === 6) {
//                         setSelectedRegion(selectedOptions);
//                       }

//                       const validScopeIds =
//                         selectedOptions.length > 0
//                           ? selectedOptions.map((item) =>
//                               typeof item === "object" ? item.id : item
//                             )
//                           : null;

//                       setFormData((prevFormData) => ({
//                         ...prevFormData,
//                         scope_ref_id: validScopeIds,
//                       }));
//                     }}
//                     options={
//                       // selectScope === 1
//                       //   ? batchData
//                       //     .filter((batch) => batch.course_id === selectedCourse)
//                       //     .map((batch) => ({
//                       //       label: batch.label,
//                       //       id: batch.id,
//                       //     }))
//                       selectScope === 1
//                         ? batchData
//                             .filter(
//                               (batch) =>
//                                 batch.course_id === selectedCourse &&
//                                 selectedClass.includes(batch.class_id)
//                             )
//                             .map((batch) => ({
//                               label: batch.label,
//                               id: batch.id,
//                             }))
//                         : selectScope === 2
//                         ? branchData.map((branch) => ({
//                             label: branch.label,
//                             id: branch.id,
//                           }))
//                         : selectScope === 3
//                         ? zoneData.map((zone) => ({
//                             label: zone.label,
//                             id: zone.id,
//                           }))
//                         : selectScope === 4
//                         ? cityData.map((city) => ({
//                             label: city.label,
//                             id: city.id,
//                           }))
//                         : selectScope === 5
//                         ? stateData.map((state) => ({
//                             label: state.label,
//                             id: state.id,
//                           }))
//                         : []
//                     }
//                     placeholder={
//                       selectScope === 1
//                         ? "Search Batch"
//                         : selectScope === 2
//                         ? "Search Branch"
//                         : selectScope === 3
//                         ? "Search Zone"
//                         : selectScope === 4
//                         ? "Search City"
//                         : selectScope === 5
//                         ? "Search State"
//                         : selectScope === 6
//                         ? "Search Region"
//                         : "Select an option"
//                     }
//                     minheight="250px"
//                     Height="auto"
//                     OverFlow="auto"
//                     showSelectAll={true}
//                     // disabled={selectScope === 7}
//                     disabled={
//                       readOnlyMode ||
//                       selectScope === 7 ||
//                       !!selectedtestSeriesId
//                     }
//                   />
//                 </div> */}
//                 <div className="item9">
//                   <DropDown
//                     label="Apply Pattern"
//                     setSelected={(selectedOption) => {
//                       setSelectedPattern(selectedOption || null);
//                       const selectedPatternObj = patternsData.find(
//                         (pattern) => pattern.id === selectedOption
//                       );
//                       if (selectedPatternObj) {
//                         const { subjects, details } = selectedPatternObj;
//                         const newCheckedSubjects = {};
//                         const newExpandedSubjects = {};
//                         const newSelectedChapters = {};
//                         const newSpecialInstructions = {};
//                         const newDifficultyDistributions = {};
//                         const newQuestionCounts = {};
//                         const newFormSubjects = [];

//                         let totalQuestions = 0;

//                         subjects.forEach((subj) => {
//                           const subjectId = subj.subject_id;
//                           const easy = subj.easy || 0;
//                           const medium = subj.medium || 0;
//                           const tough = subj.tough || 0;
//                           const total = easy + medium + tough;
//                           //  Set checkbox checked
//                           newCheckedSubjects[subjectId] = true;
//                           newExpandedSubjects[subjectId] = false;

//                           //  Select chapters
//                           newSelectedChapters[subjectId] = subj.chapters.map(
//                             (ch) => ch.chapter_id
//                           );

//                           //  Special Instructions
//                           newSpecialInstructions[subjectId] =
//                             subj.special_inst || "";

//                           //  Difficulty slider values
//                           newDifficultyDistributions[subjectId] = {
//                             firstSegment: easy,
//                             secondSegment: medium,
//                             calculatedValue: tough,
//                           };

//                           //  Set question count to easy + medium + tough
//                           newQuestionCounts[subjectId] = total;
//                           totalQuestions += total;

//                           //  Update formData subjects array
//                           newFormSubjects.push({
//                             subject_id: subjectId,
//                             easy,
//                             medium,
//                             tough,
//                             special_inst: subj.special_inst || "",
//                             chapters: subj.chapters || [],
//                           });

//                           //  Fetch chapters if not cached
//                           if (!chapterData[subjectId]) {
//                             fetch(
//                               `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_id=${subjectId}`
//                             )
//                               .then((res) => res.json())
//                               .then((data) => {
//                                 setChapterData((prev) => ({
//                                   ...prev,
//                                   [subjectId]: data,
//                                 }));
//                               });
//                           }
//                         });

//                         //  Apply all state updates
//                         setCheckedSubjects(newCheckedSubjects);
//                         setExpandedSubjects(newExpandedSubjects);
//                         setSelectedChapters(newSelectedChapters);
//                         setSpecialInstructions(newSpecialInstructions);
//                         setDifficultyDistributions(newDifficultyDistributions);
//                         setTotalQuestionCount(totalQuestions);
//                         setSelectedSubjects(subjects);
//                         setSubjects((prevSubjects) =>
//                           prevSubjects.map((subj) => {
//                             const patternSubj =
//                               selectedPatternObj.subjects.find(
//                                 (ps) => ps.subject_id === subj.subject_id
//                               );
//                             const isUserModified =
//                               manuallyUpdatedSubjects[subj.subject_id];
//                             if (patternSubj && !isUserModified) {
//                               const total =
//                                 (patternSubj.easy || 0) +
//                                 (patternSubj.medium || 0) +
//                                 (patternSubj.tough || 0);
//                               return {
//                                 ...subj,
//                                 questionCount: total,
//                               };
//                             }

//                             return subj; // leave untouched
//                           })
//                         );
//                         setFormData((prevFormData) => ({
//                           ...prevFormData,
//                           total_questions: totalQuestions,
//                           ques_paper_type: details.ques_paper_type || null,
//                           subjects: newFormSubjects,
//                         }));
//                       }
//                     }}
//                     options={
//                       patternsData.length > 0
//                         ? patternsData
//                         : [{ id: "", label: "No Patterns Available" }]
//                     }
//                     minheight="250px"
//                     Height="auto"
//                     OverFlow="auto"
//                     disabled={readOnlyMode || !!selectedtestSeriesId}
//                   />
//                 </div>
//                 <div className="item7-ques-paper-guideline-del">
//                   <FormInputs
//                     label="Description"
//                     value={formData.description}
//                     onChange={(e) =>
//                       setFormData({ ...formData, description: e.target.value })
//                     }
//                     disabled={readOnlyMode}
//                     required
//                   />
//                 </div>
//                 <div className="item7-ques-paper-guideline-del">
//                   <label>Guideline</label>
//                   <textarea
//                     placeholder="Write your guidelines here..."
//                     value={formData.guidelines} // Controlled component
//                     onChange={(e) =>
//                       setFormData({ ...formData, guidelines: e.target.value })
//                     }
//                     disabled={readOnlyMode}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//       {/* SUBJECTS Section */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>SUBJECTS</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordion}>
//             {isOpen ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>
//         {isOpen && (
//           <div className="accordion-content">
//             <div>
//               <table className="table-tc-create-test" style={{ opacity: 0.8 }}>
//                 <thead>
//                   <tr>
//                     <td>Subject/Chapter</td>
//                     <td>Ques Count</td>
//                     <td>Difficulty Level</td>
//                     <td>
//                       Assign Creators
//                       <span style={{ color: "red", marginLeft: "5px" }}>*</span>
//                     </td>
//                     <td>Assign Reviewer</td>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {Array.isArray(subjects) && subjects.length > 0 ? (
//                     subjects.map((subject) => {
//                       const isChecked =
//                         checkedSubjects[subject.subject_id] || false;
//                       return (
//                         <React.Fragment key={subject.subject_id}>
//                           <tr
//                             style={{
//                               height: "62px",
//                               opacity: isChecked ? 1 : 0.8,
//                               borderBottom: expandedSubjects[subject.subject_id]
//                                 ? ""
//                                 : "1px solid #d6d6d6",
//                             }}
//                           >
//                             <td style={{ width: "12%" }}>
//                               <input
//                                 type="checkbox"
//                                 disabled={!!selectedtestSeriesId}
//                                 className="delete-question-checkbox-dqc"
//                                 checked={isChecked}
//                                 // onChange={() => handleSubjectCheck(subject.subject_id) }
//                                 onChange={() => {
//                                   if (!readOnlyMode)
//                                     handleSubjectCheck(subject.subject_id);
//                                 }}
//                                 style={{ opacity: 1 }}
//                               />
//                               <span
//                                 style={{
//                                   marginRight: "6px",
//                                   cursor: isChecked ? "pointer" : "not-allowed",
//                                   fontWeight: "bold",
//                                   opacity: isChecked ? 1 : 0.5,
//                                 }}
//                                 // onClick={() => toggleExpandSubject(subject.subject_id) }
//                                 onClick={() => {
//                                   if (!readOnlyMode)
//                                     toggleExpandSubject(subject.subject_id);
//                                 }}
//                               >
//                                 {/* {expandedSubjects[subject.subject_id] ? "−" : "+"} */}
//                                 {(selectedChapters[subject.subject_id]
//                                   ?.length || 0) === 0
//                                   ? "+"
//                                   : expandedSubjects[subject.subject_id]
//                                   ? "−"
//                                   : "+"}
//                               </span>
//                               {subject.subject_name}
//                             </td>
//                             <td style={{ width: "7%" }}>
//                               <input
//                                 type="text"
//                                 className="input-details-nts-cr-test"
//                                 maxLength={3}
//                                 value={
//                                   isChecked ? subject.questionCount || "" : ""
//                                 }
//                                 onChange={(e) =>
//                                   handleQuestionCountChange(
//                                     subject.subject_id,
//                                     e.target.value
//                                   )
//                                 }
//                                 style={{ opacity: isChecked ? 1 : 0.8 }}
//                                 // readOnly={!isChecked}
//                                 readOnly={
//                                   !isChecked ||
//                                   readOnlyMode ||
//                                   !!selectedtestSeriesId
//                                 }
//                               />
//                             </td>
//                             <td style={{ width: "30%" }}>
//                               <MultiProgress
//                                 total={
//                                   isChecked
//                                     ? parseInt(subject.questionCount, 10) || 0
//                                     : 0
//                                 }
//                                 onSliderChange={(values) =>
//                                   handleSliderChange(subject.subject_id, values)
//                                 }
//                                 defaultValues={
//                                   difficultyDistributions[subject.subject_id]
//                                 }
//                                 isEnabled={!readOnlyMode}
//                               />
//                             </td>
//                             <td style={{ width: "12%", verticalAlign: "top" }}>
//                               <div className="input-wrapper-column">
//                                 <div className="input-wrapper-top">
//                                   <FacultySelectorPreselected
//                                     isMultiSelect={true}
//                                     userId={userId}
//                                     selectedSubjectId={subject.subject_id}
//                                     isChecked={isChecked}
//                                     selectedFacultiesProp={
//                                       selectedCreatorsBySubject[
//                                         subject.subject_id
//                                       ] || []
//                                     }
//                                     onSelectionChange={(selectedFaculties) => {
//                                       setSelectedCreatorsBySubject((prev) => ({
//                                         ...prev,
//                                         [subject.subject_id]: selectedFaculties,
//                                       }));
//                                     }}
//                                     excludeUserIds={(
//                                       selectedReviewersBySubject[
//                                         subject.subject_id
//                                       ] || []
//                                     ).map((f) => f.user_id)}
//                                     disabled={readOnlyMode}
//                                   />
//                                   <img
//                                     src={NotesIcon}
//                                     alt="Notes Icon"
//                                     className="outside-icon-notes"
//                                     // onClick={() => toggleNotesInput(subject.subject_id)}
//                                     // style={{
//                                     //   cursor: isChecked ? "pointer" : "not-allowed",
//                                     //   opacity: isChecked ? 1 : 0.5,
//                                     // }}
//                                     onClick={() => {
//                                       if (!readOnlyMode)
//                                         toggleNotesInput(subject.subject_id);
//                                     }}
//                                     style={{
//                                       cursor: readOnlyMode
//                                         ? "not-allowed"
//                                         : "pointer",
//                                       opacity: readOnlyMode ? 0.5 : 1,
//                                     }}
//                                   />
//                                 </div>
//                                 {/** Only render input if needed */}
//                                 {openNotes[subject.subject_id] && isChecked && (
//                                   <input
//                                     type="text"
//                                     className="assign-notes-input"
//                                     placeholder="Add a note..."
//                                     value={
//                                       specialInstructions[subject.subject_id] ||
//                                       ""
//                                     }
//                                     onChange={(e) =>
//                                       handleSpecialInstructionChange(
//                                         subject.subject_id,
//                                         e.target.value
//                                       )
//                                     }
//                                     // disabled={!isChecked}
//                                     disabled={!isChecked || readOnlyMode}
//                                   />
//                                 )}
//                               </div>
//                             </td>
//                             <td style={{ width: "18%" }}>
//                               <div
//                                 className="input-wrapper"
//                                 style={{
//                                   opacity: isChecked ? 1 : 0.8,
//                                   position: "relative",
//                                 }}
//                               >
//                                 <FacultySelectorPreselected
//                                   isMultiSelect={false}
//                                   userId={userId}
//                                   selectedSubjectId={subject.subject_id}
//                                   isChecked={isChecked}
//                                   selectedFacultiesProp={
//                                     selectedReviewersBySubject[
//                                       subject.subject_id
//                                     ] || []
//                                   }
//                                   onSelectionChange={(selectedFaculties) => {
//                                     setSelectedReviewersBySubject((prev) => ({
//                                       ...prev,
//                                       [subject.subject_id]: selectedFaculties,
//                                     }));
//                                   }}
//                                   excludeUserIds={(
//                                     selectedCreatorsBySubject[
//                                       subject.subject_id
//                                     ] || []
//                                   ).map((f) => f.user_id)}
//                                   disabled={readOnlyMode}
//                                 />
//                               </div>
//                             </td>
//                           </tr>
//                           {expandedSubjects[subject.subject_id] &&
//                             isChecked && (
//                               <tr
//                                 style={{ borderBottom: "1px solid  #d6d6d6" }}
//                               >
//                                 <td colSpan="5">
//                                   <div className="chapter-list-create-test">
//                                     <ul>
//                                       <li style={{ marginBottom: "14px" }}>
//                                         <input
//                                           type="checkbox"
//                                           ref={(el) => {
//                                             if (el) {
//                                               const total =
//                                                 chapterData[subject.subject_id]
//                                                   ?.length || 0;
//                                               const selected =
//                                                 selectedChapters[
//                                                   subject.subject_id
//                                                 ]?.length || 0;
//                                               el.indeterminate =
//                                                 selected > 0 &&
//                                                 selected < total;
//                                             }
//                                           }}
//                                           className={
//                                             selectedChapters[subject.subject_id]
//                                               ?.length ===
//                                             chapterData[subject.subject_id]
//                                               ?.length
//                                               ? "delete-question-checkbox-dqc"
//                                               : selectedChapters[
//                                                   subject.subject_id
//                                                 ]?.length > 0
//                                               ? "expend-chapt-sub-check-box indeterminate"
//                                               : "expend-chapt-sub-check-box"
//                                           }
//                                           onChange={() =>
//                                             handleSelectAllChapters(
//                                               subject.subject_id
//                                             )
//                                           }
//                                           checked={
//                                             selectedChapters[subject.subject_id]
//                                               ?.length ===
//                                             chapterData[subject.subject_id]
//                                               ?.length
//                                           }
//                                         />
//                                         Chapters
//                                       </li>
//                                       {Array.isArray(
//                                         chapterData[subject.subject_id]
//                                       ) &&
//                                       chapterData[subject.subject_id].length >
//                                         0 ? (
//                                         chapterData[subject.subject_id].map(
//                                           (chapter) => (
//                                             <li
//                                               key={chapter.chapter_id}
//                                               className="chapter-item-cr-ts"
//                                             >
//                                               <input
//                                                 type="checkbox"
//                                                 className="delete-question-checkbox-dqc"
//                                                 checked={
//                                                   selectedChapters[
//                                                     subject.subject_id
//                                                   ]?.includes(
//                                                     chapter.chapter_id
//                                                   ) || false
//                                                 }
//                                                 onChange={() =>
//                                                   handleChapterCheck(
//                                                     subject.subject_id,
//                                                     chapter.chapter_id
//                                                   )
//                                                 }
//                                               />
//                                               {chapter.chapter_name}
//                                             </li>
//                                           )
//                                         )
//                                       ) : (
//                                         <div className="chapter-details">
//                                           No chapters available
//                                         </div>
//                                       )}
//                                     </ul>
//                                   </div>
//                                 </td>
//                               </tr>
//                             )}
//                         </React.Fragment>
//                       );
//                     })
//                   ) : (
//                     <tr>
//                       <td colSpan="5" style={{ textAlign: "center" }}>
//                         No subjects available
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//             <div className="total-question-count-cr-test">
//               <span>Total Questions: </span> {totalQuestionCount}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default CurateQuestionPaperEdit;















import React, { useState, useEffect, useId } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
// import "./createques.css";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import SelectedDropdownValues from "../CurateQuestionPaper/SelectedDropdownValues";
// import { fetchClassData } from "../../../Redux/StudentRegistration/classSlice";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import NotesIcon from "./../../../Assets/Images/CommanImages/grommet-icons_notes.png";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import ErrorIcon from "./../../../Assets/Images/CommanImages/Error.png";
import SuccessImg from "./../../../Assets/Images/CommanImages/Informative.png";
import MultiSeledDropdown from "../MultiDropdown/MultiSeledDropdown";
import MultiProgress from "../MultiProgressBar/MultiProgress";
// import { fetchScopeData } from "../../../Redux/Scope/ScopeSlice";
import { API_BASE_URL } from "../../../Config/Config";
import FacultySelectorPreselected from "./FacultySelectorPreselected";
import MultiSelectSearchDropdown from "../SearchDropDown/MultiSelectSearchDropdown";
import EndPoints from "../../../Api/Endpoints";
import { POST, GET } from "../../../Api/HttpsMethods";

function CurateQuestionPaperEdit({
  dataClient,
  setMessageBox,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  setNoTimeSet,
}) {
  const [questionPaperType, setQuestionPaperType] = useState(null);
  const [selectedtestSeriesId, setSelectedTestSeriesID] = useState(1);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const quesPaperIdFromURL = searchParams.get("MNTQuestionPaperID");
  const [readOnlyMode, setReadOnlyMode] = useState(true);
  const { coursesdata = [] } = useSelector((state) => state.course) || {};
  const { classData = [] } = useSelector((state) => state.classname) || {};
  const { scopeData = [] } = useSelector((state) => state.scopes) || {};
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedClass, setSelectedClass] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [expandedSubjects, setExpandedSubjects] = useState({});
  const [chapterData, setChapterData] = useState({});
  const [checkedSubjects, setCheckedSubjects] = useState({});
  const [isOpen, setIsOpen] = useState(true);
  const [isOpenSubject, setIsOpenSubject] = useState(true);
  const [totalQuestionCount, setTotalQuestionCount] = useState(0);
  const [QuestionTypeId, setQuestionTypeID] = useState(null);
  const [selectedChapters, setSelectedChapters] = useState({});
  const [difficultyDistributions, setDifficultyDistributions] = useState({});
  const [selectScope, setSelectedScope] = useState(null);
  const [openNotes, setOpenNotes] = useState({});
  const [batchData, setBatchData] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]); // State selection
  const [stateData, setStateData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [selectedZone, setSelectedZone] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [zoneData, setZoneData] = useState([]);
  const [selectedFaculties, setSelectedFaculties] = useState([]);
  const [selectedAssigReviewerFaculties, setSelectedAssigReviewerFaculties] = useState([]);
  const [selectedCreatorsBySubject, setSelectedCreatorsBySubject] = useState( {} );
  const [selectedReviewersBySubject, setSelectedReviewersBySubject] = useState( {} );
  const [dropdownKey, setDropdownKey] = useState(0);
  const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
  const userId = dataClient && dataClient.client_schema_name[6][0].user_id;
  const [specialInstructions, setSpecialInstructions] = useState({});
  const [patternsData, setPatternsData] = useState([]);
  const [selectedPatternDetails, setSelectedPatternDetails] = useState(null);
  const [selectedPattern, setSelectedPattern] = useState(null);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [testSeriesOptions, setTestSeriesOptions] = useState([]);
  const [testSeriesData, setTestSeriesData] = useState([]);
  const [manuallyUpdatedSubjects, setManuallyUpdatedSubjects] = useState({});
  const accessToken = localStorage.getItem("other");
  const [canEdit, setCanEdit] = useState(true);

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      client_branch_id: clientBranchId,
      created_by: userName,
    }));
  }, [clientBranchId, userName]);

  useEffect(() => {
    // dispatch(fetchClassData());
    dispatch(fetchCourseData());
    // dispatch(fetchScopeData());
  }, [dispatch]);

  // ─── CHANGED: deduplicate by subject_superset_id, display subject_superset_name ───
  useEffect(() => {
    const fetchSubjectsByCourse = async () => {
      if (!selectedCourse) {
        setSubjects([]);
        return;
      }
      try {
        const API_ENDPOINT = `${EndPoints.PRISM_GET_SUBJECTS_BY_COURSE}?course_id=${selectedCourse}`;
        const data = await GET.withToken(API_ENDPOINT);

        if (!Array.isArray(data)) {
          setSubjects([]);
          return;
        }

        // Deduplicate by subject_superset_id; map superset fields onto subject_id/subject_name
        const seen = new Set();
        const deduplicated = data.reduce((acc, item) => {
          if (!seen.has(item.subject_superset_id)) {
            seen.add(item.subject_superset_id);
            acc.push({
              subject_id: item.subject_superset_id,       // superset_id used as key throughout
              subject_name: item.subject_superset_name,   // superset_name shown in UI
              subject_desc: item.subject_superset_desc,
            });
          }
          return acc;
        }, []);

        setSubjects(deduplicated);
      } catch (error) {
        console.error("Error fetching subjects:", error);
        setSubjects([]);
      }
    };
    fetchSubjectsByCourse();
  }, [selectedCourse]);

  const handleSubjectCheck = async (subjectId) => {
    let shouldFetchChapters = false;

    setCheckedSubjects((prev) => {
      const isChecked = !prev[subjectId];
      const chapters = chapterData[subjectId] || [];

      if (isChecked) {
        setSelectedChapters((prevChapters) => ({
          ...prevChapters,
          [subjectId]: chapters.map((ch) => ch.chapter_id),
        }));

        setFormData((prevFormData) => ({
          ...prevFormData,
          subjects: [
            ...prevFormData.subjects.filter(
              (s) => s.subject_superset_id !== subjectId
            ),
            {
              subject_superset_id: subjectId,
              easy: 0,
              medium: 0,
              tough: 0,
              special_inst: "",
              chapters: chapters.map((ch) => ({
                chapter_id: ch.chapter_id,
              })),
            },
          ],
        }));
      } else {
        setSelectedChapters((prevChapters) => ({
          ...prevChapters,
          [subjectId]: [],
        }));

        setFormData((prevFormData) => ({
          ...prevFormData,
          subjects: prevFormData.subjects.filter(
            (s) => s.subject_superset_id !== subjectId
          ),
        }));
      }

      if (!chapterData[subjectId]) {
        shouldFetchChapters = true;
      }

      return { ...prev, [subjectId]: isChecked };
    });

    if (!shouldFetchChapters) return;

    try {
      // ─── CHANGED: use subject_superset_id param ───
      const API_ENDPOINT = `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${subjectId}`;
      const data = await GET.withToken(API_ENDPOINT);

      const chapters = Array.isArray(data) ? data : [];

      setChapterData((prev) => ({
        ...prev,
        [subjectId]: chapters,
      }));

      setSelectedChapters((prevChapters) => ({
        ...prevChapters,
        [subjectId]: chapters.map((ch) => ch.chapter_id),
      }));

      setFormData((prevFormData) => ({
        ...prevFormData,
        subjects: [
          ...prevFormData.subjects.filter(
            (s) => s.subject_superset_id !== subjectId
          ),
          {
            subject_superset_id: subjectId,
            easy: 0,
            medium: 0,
            tough: 0,
            special_inst: "",
            chapters: chapters.map((ch) => ({
              chapter_id: ch.chapter_id,
            })),
          },
        ],
      }));
    } catch (error) {
      console.error("Error fetching chapters:", error);
    }
  };

  const toggleExpandSubject = async (subjectId) => {
    if (!checkedSubjects[subjectId]) return;

    setExpandedSubjects((prev) => ({
      ...prev,
      [subjectId]: !prev[subjectId],
    }));

    if (chapterData[subjectId]) return;

    try {
      // ─── CHANGED: use subject_superset_id param ───
      const API_ENDPOINT = `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${subjectId}`;
      const data = await GET.withToken(API_ENDPOINT);

      const chapters = Array.isArray(data) ? data : [];

      setChapterData((prev) => ({
        ...prev,
        [subjectId]: chapters,
      }));

      setSelectedChapters((prevChapters) => ({
        ...prevChapters,
        [subjectId]: chapters.map((ch) => ch.chapter_id),
      }));
    } catch (error) {
      console.error("Error fetching chapters:", error);
    }
  };

  const handleChapterCheck = (subjectId, chapterId) => {
    setSelectedChapters((prevChapters) => {
      const isSelected = prevChapters[subjectId]?.includes(chapterId);
      const updatedChapters = isSelected
        ? prevChapters[subjectId].filter((id) => id !== chapterId)
        : [...(prevChapters[subjectId] || []), chapterId];
      return { ...prevChapters, [subjectId]: updatedChapters };
    });
  };

  const handleSelectAllChapters = (subjectId) => {
    const allSelected =
      selectedChapters[subjectId]?.length === chapterData[subjectId]?.length;

    const updatedChapters = allSelected
      ? []
      : chapterData[subjectId].map((ch) => ch.chapter_id);

    setSelectedChapters((prevChapters) => ({
      ...prevChapters,
      [subjectId]: updatedChapters,
    }));

    setCheckedSubjects((prev) => ({
      ...prev,
      [subjectId]: !allSelected, 
    }));

    setFormData((prevFormData) => {
      const filteredSubjects = prevFormData.subjects.filter(
        (s) => s.subject_superset_id !== subjectId
      );

      if (allSelected) {
        return {
          ...prevFormData,
          subjects: filteredSubjects,
        };
      } else {
        return {
          ...prevFormData,
          subjects: [
            ...filteredSubjects,
            {
              subject_superset_id: subjectId,
              easy: difficultyDistributions[subjectId]?.firstSegment || 0,
              medium: difficultyDistributions[subjectId]?.secondSegment || 0,
              tough: difficultyDistributions[subjectId]?.calculatedValue || 0,
              special_inst: specialInstructions[subjectId] || "",
              chapters: updatedChapters.map((id) => ({ chapter_id: id })),
            },
          ],
        };
      }
    });
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const toggleAccordionSubjects = () => {
    setIsOpenSubject(!isOpenSubject);
  };

  const handleQuestionCountChange = (subjectId, value) => {
    if (/^\d*$/.test(value)) {
      const parsedValue = parseInt(value || 0, 10);

      setManuallyUpdatedSubjects((prev) => ({
        ...prev,
        [subjectId]: true,
      }));

      setSubjects((prevSubjects) =>
        prevSubjects.map((subject) =>
          subject.subject_id === subjectId
            ? { ...subject, questionCount: parsedValue }
            : subject
        )
      );

      const easy = Math.floor(parsedValue / 3);
      const medium = Math.floor(parsedValue / 3);
      const tough = parsedValue - (easy + medium);

      const newDistribution = {
        firstSegment: easy,
        secondSegment: medium,
        calculatedValue: tough,
      };

      setDifficultyDistributions((prev) => ({
        ...prev,
        [subjectId]: newDistribution,
      }));

      setFormData((prevFormData) => {
        const updatedSubjects = prevFormData.subjects.map((subject) => {
          if (subject.subject_superset_id === subjectId) {
            return {
              ...subject,
              easy,
              medium,
              tough,
            };
          }
          return subject;
        });

        return {
          ...prevFormData,
          subjects: updatedSubjects,
        };
      });

      const newTotal = subjects.reduce((acc, subject) => {
        const count =
          subject.subject_id === subjectId
            ? parsedValue
            : parseInt(subject.questionCount || 0, 10);
        return acc + count;
      }, 0);
      setTotalQuestionCount(newTotal);
    }
  };

  const handleSliderChange = (subjectId, values) => {
    setDifficultyDistributions((prev) => ({
      ...prev,
      [subjectId]: values,
    }));

    setFormData((prevFormData) => {
      const updatedSubjects = prevFormData.subjects.map((subject) => {
        if (subject.subject_superset_id === subjectId) {
          return {
            ...subject,
            easy: values.firstSegment || 0,
            medium: values.secondSegment || 0,
            tough: values.calculatedValue || 0,
          };
        }
        return subject;
      });

      return {
        ...prevFormData,
        subjects: updatedSubjects,
      };
    });
  };

  const toggleNotesInput = (subjectId) => {
    if (!checkedSubjects[subjectId]) return; // Prevent opening if subject is not selected
    setOpenNotes((prev) => ({
      ...prev,
      [subjectId]: !prev[subjectId],
    }));

    if (!specialInstructions[subjectId]) {
      setSpecialInstructions((prev) => ({
        ...prev,
        [subjectId]: "",
      }));
    }
  };

  const [formData, setFormData] = useState({
    ques_paper_name: "",
    description: "",
    ques_paper_type: QuestionTypeId,
    course_id: selectedCourse,
    ques_paper_series: selectedPattern,
    due_date: "",
    ques_paper_scope_id: selectScope,
    test_series_id: selectedtestSeriesId,
    scope_ref_id: null,
    client_branch_id: clientBranchId,
    created_by: userName,
    status: 1,
    guidelines: "",
    classes: selectedClass,
    subjects: [
      {
        subject_superset_id: 0,
        easy: 0,
        medium: 0,
        tough: 0,
        special_inst: "",
        chapters: [],
      },
    ],
    assign_creators: [
      {
        subject_superset_id: 0,
        user_ids: selectedFaculties.map((faculty) => faculty.user_id),
      },
    ],
    assign_reviewers: [
      { subject_superset_id: 0, user_id: selectedAssigReviewerFaculties.user_id },
    ],
  });

  // Add this logic to update the subjects with question counts on deployment 01/07/2025
  useEffect(() => {
    if (!subjects || subjects.length === 0) return;
    if (!formData || !formData.subjects || formData.subjects.length === 0)
      return;

    const questionCounts = {};
    for (const subj of formData.subjects) {
      const count = (subj.easy || 0) + (subj.medium || 0) + (subj.tough || 0);
      questionCounts[subj.subject_superset_id] = count;
    }

    setSubjects((prev) =>
      prev.map((s) => ({
        ...s,
        questionCount: questionCounts[s.subject_id] || 0,
      }))
    );
  }, [subjects, formData]);

  const handleSpecialInstructionChange = (subjectId, value) => {
    setSpecialInstructions((prev) => ({
      ...prev,
      [subjectId]: value,
    }));
  };

  useEffect(() => {
    const fetchPatterns = async () => {
      if (!selectedCourse) {
        setPatternsData([]);
        setSelectedPatternDetails(null);
        setSelectedSubjects([]);
        return;
      }

      try {
        const API_ENDPOINT = `${EndPoints.PRISM_GET_PATTERN_DETAILS}?course_id=${selectedCourse}`;
        const data = await GET.withToken(API_ENDPOINT);

        if (
          !data ||
          !Array.isArray(data.question_papers) ||
          data.question_papers.length === 0
        ) {
          setPatternsData([]);
          setSelectedPatternDetails(null);
          setSelectedSubjects([]);
          return;
        }

        const formattedPatterns = data.question_papers.map((pattern) => ({
          id: pattern.ques_paper_layout.ques_paper_layout_id,
          label: `${pattern.ques_paper_layout.ques_paper_layout_name} - ${pattern.ques_paper_layout.ques_paper_layout_desc}`,
          details: pattern.ques_paper_details,
          subjects: pattern.subjects || [],
        }));

        setPatternsData(formattedPatterns);
        setSelectedPatternDetails(formattedPatterns[0]?.details || null);
        setSelectedSubjects(formattedPatterns[0]?.subjects || []);
      } catch (error) {
        console.error("Error fetching pattern details:", error);
        setPatternsData([]);
        setSelectedPatternDetails(null);
        setSelectedSubjects([]);
      }
    };

    fetchPatterns();
  }, [selectedCourse]);

  useEffect(() => {
    if (!clientBranchId || !selectedCourse || questionPaperType !== 2) {
      setTestSeriesOptions([]);
      setTestSeriesData([]);
      return;
    }
    const apiUrl = `${EndPoints.PRISM_GET_TEST_SERIES_LIST_BY_BRANCH}?client_branch_id=${clientBranchId}`;
    const fetchTestSeries = async () => {
      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        const data = await response.json();

        if (data?.status === 200 && Array.isArray(data.data)) {
          const filtered = data.data.filter(
            (item) => item.course_id === selectedCourse
          );
          const unique = Array.from(
            new Map(filtered.map((ts) => [ts.ts_id, ts])).values()
          );

          const options = unique.map((item) => ({
            id: item.ts_id,
            label: item.ts_name,
          }));

          setTestSeriesOptions(options);
          setTestSeriesData(unique); 
        }
      } catch (err) {
        console.error("Test series fetch failed", err);
      }
    };
    fetchTestSeries();
  }, [clientBranchId, selectedCourse, questionPaperType]);

  useEffect(() => {
    if (!quesPaperIdFromURL) return;

    const fetchQuesPaperDetails = async () => {
      try {
        const API_ENDPOINT =
          `${EndPoints.PRISM_GET_CURATE_QUES_PAPER_DETAILS_BY_PAPER_ID}?ques_paper_id=${quesPaperIdFromURL}`;

        const result = await GET.withToken(API_ENDPOINT);

        if (result?.status !== 200 || !result.data) return;

        const data = result.data;

        setCanEdit(Boolean(data.edit));
        setSelectedCourse(data.course_id);
        setQuestionPaperType(data.ques_paper_type);
        setSelectedClass(data.class_ids);
        setSelectedTestSeriesID(data.test_series || null);

        setFormData((prev) => ({
          ...prev,
          ques_paper_name: data.ques_paper_name,
          description: data.description,
          guidelines: data.guideline,
          due_date: data.due_date,
          ques_paper_type: data.ques_paper_type,
          course_id: data.course_id,
          classes: data.class_ids,
          test_series_id: data.test_series || null,
        }));

        /* ---------- Scope detection ---------- */
        let detectedScopeId = null;
        let detectedScopeRefIds = [];

        if (Array.isArray(data.scope_detail) && data.scope_detail.length > 0) {
          const r0 = data.scope_detail[0];

          if ("batch_id" in r0) {
            detectedScopeId = 1;
            detectedScopeRefIds = data.scope_detail.map((s) => s.batch_id);
            setSelectedBatch(detectedScopeRefIds);
          } else if ("branch_id" in r0) {
            detectedScopeId = 2;
            detectedScopeRefIds = data.scope_detail.map((s) => s.branch_id);
            setSelectedBranch(detectedScopeRefIds);
          } else if ("zone_id" in r0 || "city_zone_id" in r0) {
            detectedScopeId = 3;
            detectedScopeRefIds = data.scope_detail.map(
              (s) => s.zone_id ?? s.city_zone_id
            );
            setSelectedZone(detectedScopeRefIds);
          } else if ("city_id" in r0) {
            detectedScopeId = 4;
            detectedScopeRefIds = data.scope_detail.map((s) => s.city_id);
            setSelectedCities(detectedScopeRefIds);
          } else if ("state_id" in r0) {
            detectedScopeId = 5;
            detectedScopeRefIds = data.scope_detail.map((s) => s.state_id);
            setSelectedStates(detectedScopeRefIds);
          } else if ("region_id" in r0) {
            detectedScopeId = 6;
            detectedScopeRefIds = data.scope_detail.map((s) => s.region_id);
            setSelectedRegion(detectedScopeRefIds);
          }
        }

        setSelectedScope(detectedScopeId);
        setFormData((prev) => ({
          ...prev,
          ques_paper_scope_id: detectedScopeId,
          scope_ref_id: detectedScopeRefIds,
        }));

        /* ---------- Subjects ---------- */
        const newCheckedSubjects = {};
        const newDifficulty = {};
        const newFormSubjects = [];
        const questionCounts = {};
        let totalQues = 0;

        const chapterFetchPromises = [];

        for (const subjectId of Object.keys(data.subject_info)) {
          const info = data.subject_info[subjectId];
          const sid = Number(subjectId);

          newCheckedSubjects[sid] = true;
          questionCounts[sid] = info.ques_count;
          totalQues += info.ques_count;

          newDifficulty[sid] = {
            firstSegment: info.easy,
            secondSegment: info.medium,
            calculatedValue: info.tough,
          };

          setSelectedChapters((prev) => ({
            ...prev,
            [sid]: info.chapters || [],
          }));

          newFormSubjects.push({
            subject_superset_id: sid,
            easy: info.easy,
            medium: info.medium,
            tough: info.tough,
            special_inst: info.instructions || "",
            chapters: (info.chapters || []).map((id) => ({
              chapter_id: id,
            })),
          });

          /* ---------- Creators ---------- */
          setSelectedCreatorsBySubject((prev) => ({
            ...prev,
            [sid]: (info.creators || []).map((u) => {
              const [lastName, firstMiddle = ""] = u.user_name.split(",");
              const [firstName = "", middleName = ""] =
                firstMiddle.trim().split(" ");
              return {
                user_id: u.user_id,
                emp_first_name: firstName,
                emp_middle_name: middleName,
                emp_last_name: lastName,
              };
            }),
          }));

          /* ---------- Reviewers ---------- */
          setSelectedReviewersBySubject((prev) => ({
            ...prev,
            [sid]: (info.reviewers || []).map((u) => {
              const [lastName, firstMiddle = ""] = u.user_name.split(",");
              const [firstName = "", middleName = ""] =
                firstMiddle.trim().split(" ");
              return {
                user_id: u.user_id,
                emp_first_name: firstName,
                emp_middle_name: middleName,
                emp_last_name: lastName,
              };
            }),
          }));

          /* ---------- Fetch chapters if missing ---------- */
          if (!chapterData[sid]) {
            chapterFetchPromises.push(
              GET.withToken(
                `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${sid}`
              ).then((chapters) => {
                setChapterData((prev) => ({
                  ...prev,
                  [sid]: Array.isArray(chapters) ? chapters : [],
                }));
              })
            );
          }
        }

        await Promise.all(chapterFetchPromises);

        setCheckedSubjects(newCheckedSubjects);
        setDifficultyDistributions(newDifficulty);
        setTotalQuestionCount(totalQues);

        setSubjects((prev) =>
          prev.map((s) => ({
            ...s,
            questionCount: questionCounts[s.subject_id] || 0,
          }))
        );

        setFormData((prev) => ({
          ...prev,
          subjects: newFormSubjects,
        }));
      } catch (err) {
        console.error("Failed to fetch question paper details", err);
      }
    };

    fetchQuesPaperDetails();
  }, [quesPaperIdFromURL]);

  const handleSaveEditedPaper = async () => {
    let errorMessage = "";
    if (!formData.due_date) {
      errorMessage = "Due Date is required.";
    } else {
      const dueDate = new Date(formData.due_date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      dueDate.setHours(0, 0, 0, 0);
      if (isNaN(dueDate.getTime())) {
        errorMessage = "Please enter a valid due date.";
      } else if (dueDate < today) {
        errorMessage = "Due date cannot be in the past.";
      }
    }
    const selectedSubjects = subjects.filter(
      (subject) => checkedSubjects[subject.subject_id]
    );
    if (!errorMessage && selectedSubjects.length === 0) {
      errorMessage = "At least one subject must be selected.";
    }
    const hasZeroQuestionCount = selectedSubjects.some(
      (subject) => (parseInt(subject.questionCount, 10) || 0) === 0
    );
    if (!errorMessage && hasZeroQuestionCount) {
      errorMessage = "Question count cannot be zero for any selected subject.";
    }

    //  Ensure question count is at least 3 for any selected subject
    const hasLessThanThreeQuestions = selectedSubjects.some(
      (subject) => {
        const count = parseInt(subject.questionCount, 10) || 0;
        return count > 0 && count < 3;
      }
    );
    
    if (!errorMessage && hasLessThanThreeQuestions) {
      errorMessage = "Question count must be at least 3 for each selected subject.";
    }
    
    const assignCreators = selectedSubjects.map((subject) => ({
      subject_superset_id: subject.subject_id,
      user_ids: (selectedCreatorsBySubject[subject.subject_id] || []).map(
        (faculty) => faculty.user_id
      ),
    }));

    const hasSubjectWithoutCreator = assignCreators.some(
      (subject) => subject.user_ids.length === 0
    );
    if (!errorMessage && hasSubjectWithoutCreator) {
      errorMessage =
        "Each selected subject must have at least one assigned creator.";
    }
    if (errorMessage) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{errorMessage}</span>
          </div>
        </div>
      );
      setActiveImg(ErrorIcon);
      return;
    }
    try {
      // const payload = {
      //   class_ids: formData.classes || [],
      //   test_series: formData.test_series_id || null,
      //   ques_paper_name: formData.ques_paper_name || "",
      //   due_date: formData.due_date || "",
      //   ques_paper_scope_id: formData.ques_paper_scope_id || null,
      //   scope_ref_id: Array.isArray(formData.scope_ref_id)
      //     ? formData.scope_ref_id.filter((id) => typeof id === "number")
      //     : [],
      //   description: formData.description || "",
      //   guideline: formData.guidelines || "",
      //   subject_info: Object.entries(checkedSubjects)
      //     .filter(([subjectId, checked]) => checked)
      //     .map(([subjectId]) => {
      //       const sid = parseInt(subjectId);
      //       const difficulty = difficultyDistributions[sid] || {};
      //       return {
      //         subject_superset_id: sid,
      //         status: 1,
      //         chapters: selectedChapters[sid] || [],
      //         instructions: specialInstructions[sid] || "",
      //         easy: difficulty.firstSegment || 0,
      //         medium: difficulty.secondSegment || 0,
      //         tough: difficulty.calculatedValue || 0,
      //         creators: (selectedCreatorsBySubject[sid] || []).map(
      //           (f) => f.user_id
      //         ),
      //         reviewers: (selectedReviewersBySubject[sid] || []).map(
      //           (f) => f.user_id
      //         ),
      //       };
      //     }),
      // };

      const payload = {
        test_series: formData.test_series_id || 0,
        ques_paper_name: formData.ques_paper_name || "",
        due_date: formData.due_date || "",
        description: formData.description || "",
        guideline: formData.guidelines || "",
        subject_info: Object.entries(checkedSubjects)
          .filter(([subjectId, checked]) => checked)
          .map(([subjectId]) => {
            const sid = parseInt(subjectId);
            const difficulty = difficultyDistributions[sid] || {};
            return {
              subject_superset_id: sid,
              status: 1,
              chapters: selectedChapters[sid] || [],
              instructions: specialInstructions[sid] || "",
              easy: difficulty.firstSegment || 0,
              medium: difficulty.secondSegment || 0,
              tough: difficulty.calculatedValue || 0,
              creators: (selectedCreatorsBySubject[sid] || []).map((f) => f.user_id),
              reviewers: (selectedReviewersBySubject[sid] || []).map((f) => f.user_id),
            };
          }),
      };

      const response = await fetch(
       `${EndPoints.PRISM_UPDATE_CURATE_QUES_PAPER_DETAILS_BY_PAPER_ID}?ques_paper_id=${quesPaperIdFromURL}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok && result.status === 200) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Question Paper updated successfully!</span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg);
        // setReadOnlyMode(true);
      } else {
        throw new Error(result.message || "Failed to update question paper");
      }
    } catch (err) {
      console.error("Error updating paper:", err);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{err.message || "Something went wrong while saving"}</span>
          </div>
        </div>
      );
      setActiveImg(ErrorIcon);
    }
  };

  const handleDeleteQuestionPaper = () => {
    setNoTimeSet(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Do you want to delete this question paper?</span>
        </div>
        <div
          className="messagebox-insider2"
          style={{ display: "flex", gap: "10px", marginTop: "10px" }}
        >
          <button
            className="messagebox-cancel-btn-ok"
            onClick={async () => {
              // YES => Call API
              setIsMessageBoxVisible(false);
              try {
                const res = await fetch(
                  `${EndPoints.PRISM_DELETE_CURATE_QUESTION_PAPER}?ques_paper_id=${quesPaperIdFromURL}&user_name=${userName}`,
                  {
                    method: "PUT",
                    headers: {
                      Authorization: `Bearer ${accessToken}`,
                      Accept: "application/json",
                    },
                  }
                );
                const result = await res.json();
                if (result.status === 200) {
                  setIsMessageBoxVisible(true);
                  setMessageBox(
                    <div className="Container-messageBOX">
                      <div className="messagebox-insider1">
                        <div className="loader-tc"></div>
                        <span>Question Paper deleted successfully!</span>
                      </div>
                    </div>
                  );
                  setActiveImg(SuccessImg);
                  setNoTimeSet(false);
                  setTimeout(() => {
                    navigate("/assignor_dashboard_details");
                  }, 500);
                } else {
                  throw new Error(result.message || "Delete failed");
                }
              } catch (err) {
                setMessageBox(
                  <div className="Container-messageBOX">
                    <div className="messagebox-insider1">
                      <div className="loader-tc"></div>
                      <span>{err.message}</span>
                    </div>
                  </div>
                );
                setActiveImg(ErrorIcon);
                setIsMessageBoxVisible(true);
              }
            }}
          >
            YES
          </button>
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
              setNoTimeSet(false);
            }}
          >
            NO
          </button>
        </div>
      </div>
    );
    setActiveImg(InterogativeImg);
    setIsMessageBoxVisible(true);
  };

  const isEditDisabled = questionPaperType === 1 && !canEdit; 
  
  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">Curate Question Paper</span>
        <div className="cr-header-btn-container">
          <button
            className="cr-cancel-btn"
            onClick={() => navigate(`/assignor_dashboard_details`)}
          >
            CANCEL
          </button>
          {readOnlyMode ? (
            <>
              <button
                className="cr-create-btn"
                onClick={handleDeleteQuestionPaper}
              >
                {" "}
                DELETE{" "}
              </button>

              <button
                type="button"
                className="cr-create-btn"
                disabled={isEditDisabled}
                onClick={!isEditDisabled ? () => setReadOnlyMode(false) : undefined}
                style={{
                  boxShadow: "0px 4px 4px 0px #00000040",
                  backgroundColor: isEditDisabled ? "#d3d3d3" : "#ffffff",
                  cursor: isEditDisabled ? "not-allowed" : "pointer",
                  color: isEditDisabled ? "#888" : "#424342",
                }}
                onMouseEnter={(e) => {
                  if (!isEditDisabled) {
                    e.currentTarget.style.backgroundColor = "#fa4741";
                    e.currentTarget.style.color = "white";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isEditDisabled) {
                    e.currentTarget.style.backgroundColor = "#ffffff";
                    e.currentTarget.style.color = "#424342";
                  }
                }}
              >
                EDIT
              </button>
            </>
          ) : (
            <button className="cr-create-btn" onClick={handleSaveEditedPaper}>
              {" "}
              SAVE{" "}
            </button>
          )}
        </div>
      </div>
      {/* QUESTION PAPER DETAIL Section */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>QUESTION PAPER DETAIL</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordionSubjects}>
            {isOpenSubject ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpenSubject && (
          <div className="accordion-content">
            <div className="select-assign-test-container-ques-pap-del">
              <div className="grid-container-ques-paper-del">
                <div className="item1">
                  <SelectedDropdownValues
                    label="Course"
                    selected={selectedCourse}
                    setSelected={(selectedOption) => {
                      setSelectedCourse(selectedOption || null);
                      setSelectedClass([]);
                      setSelectedScope(null);
                      setSelectedBatch([]);
                      setSelectedBranch([]);
                      setSelectedZone([]);
                      setSelectedCities([]);
                      setSelectedStates([]);
                      setSelectedRegion([]);
                      setSubjects([]);
                      setCheckedSubjects({});
                      setExpandedSubjects({});
                      setSelectedChapters({});
                      setSpecialInstructions({});
                      setSelectedTestSeriesID(null);
                      setTestSeriesOptions([]);
                      setTestSeriesData([]);
                      setDifficultyDistributions({});
                      setTotalQuestionCount(0);
                      setSelectedCreatorsBySubject({});
                      setSelectedReviewersBySubject({});
                      setSelectedPattern(null);
                      setSelectedPatternDetails(null);
                      setSelectedSubjects([]);
                      setFormData((prevFormData) => ({
                        ...prevFormData,
                        course_id: selectedOption || null,
                        ques_paper_scope_id: null,
                        scope_ref_id: null,
                        classes: [],
                        subjects: [],
                        test_series_id: null,
                        assign_creators: [],
                        assign_reviewers: [],
                      }));
                      setDropdownKey((prev) => prev + 1);
                    }}
                    options={
                      Array.isArray(coursesdata)
                        ? coursesdata.map((course) => ({
                            label: course.course_name,
                            id: course.course_id,
                          }))
                        : []
                    }
                    isRequired={true}
                    disabled={true}
                  />
                </div>
                <div className="item2">
                  <SelectedDropdownValues
                    label="Question Paper Type"
                    selected={questionPaperType}
                    setSelected={(selectedOption) => {
                      setQuestionPaperType(selectedOption);
                      if (selectedOption === 1) {
                        setSelectedTestSeriesID(null);
                        setDropdownKey((prev) => prev + 1); 
                        setSelectedClass([]);
                        setSelectedScope(null);
                        setSelectedBatch([]);
                        setSelectedBranch([]);
                        setSelectedZone([]);
                        setSelectedCities([]);
                        setSelectedStates([]);
                        setSelectedRegion([]);
                        setCheckedSubjects({});
                        setExpandedSubjects({});
                        setSelectedChapters({});
                        setSpecialInstructions({});
                        setDifficultyDistributions({});
                        setTotalQuestionCount(0);
                        setSelectedCreatorsBySubject({});
                        setSelectedReviewersBySubject({});
                        setSelectedPattern(null);
                        setSelectedPatternDetails(null);
                        setSelectedSubjects([]);

                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          ques_paper_type: selectedOption,
                          test_series_id: null,
                          ques_paper_scope_id: null,
                          scope_ref_id: null,
                          classes: [],
                          subjects: [],
                          assign_creators: [],
                          assign_reviewers: [],
                        }));
                      } else {
                        setFormData((prev) => ({
                          ...prev,
                          ques_paper_type: selectedOption || null,
                        }));
                      }
                    }}
                    options={[
                      { id: 1, label: "DPP" },
                      { id: 2, label: "Test" },
                    ]}
                    isRequired={true}
                    disabled={true}
                  />
                </div>
                <div className="item2">
                  <SelectedDropdownValues
                    label="Test Series"
                    key={dropdownKey}
                    selected={selectedtestSeriesId}
                    setSelected={(selectedOption) => {
                      setSelectedTestSeriesID(selectedOption);
                      setFormData((prev) => ({
                        ...prev,
                        test_series_id: selectedOption || null,
                      }));
                      const fullTS = testSeriesData.find(
                        (ts) => ts.ts_id === selectedOption
                      );
                      if (!fullTS) return;
                      const classIds = fullTS.class_id_list || [];
                      setSelectedClass(classIds);
                      setFormData((prev) => ({ ...prev, classes: classIds }));
                      setSelectedScope(fullTS.scope_id);
                      setFormData((prev) => ({
                        ...prev,
                        ques_paper_scope_id: fullTS.scope_id,
                        scope_ref_id: (fullTS.scope_ref_ids || []).map(
                          (item) => item.id
                        ),
                      }));
                      switch (fullTS.scope_id) {
                        case 1:
                          setSelectedBatch(
                            (fullTS.scope_ref_ids || []).map((item) => item.id)
                          );
                          break;
                        case 2:
                          setSelectedBranch(
                            (fullTS.scope_ref_ids || []).map((item) => item.id)
                          );
                          break;
                        case 3:
                          setSelectedZone(
                            (fullTS.scope_ref_ids || []).map((item) => item.id)
                          );
                          break;
                        case 4:
                          setSelectedCities(
                            (fullTS.scope_ref_ids || []).map((item) => item.id)
                          );
                          break;
                        case 5:
                          setSelectedStates(
                            (fullTS.scope_ref_ids || []).map((item) => item.id)
                          );
                          break;
                        case 6:
                          setSelectedRegion(
                            (fullTS.scope_ref_ids || []).map((item) => item.id)
                          );
                          break;
                        default:
                          break;
                      }
                      const checked = {};
                      const questionCounts = {};
                      const difficultyMap = {};
                      const formSubjects = [];
                      let totalCount = 0;
                      const subjectMap = {};
                      (fullTS.subject_section || []).forEach((subj) => {
                        const subjectId = subj.subject_superset_id || subj.subject_id;
                        if (!subjectMap[subjectId]) {
                          subjectMap[subjectId] = {
                            subject_superset_id: subjectId,
                            total_question_cnt: 0,
                            ms_desc: subj.ms_desc || "",
                          };
                        }
                        subjectMap[subjectId].total_question_cnt +=
                          subj.total_question_cnt || 0;
                      });

                      Object.values(subjectMap).forEach((subj) => {
                        checked[subj.subject_superset_id] = true;
                        const count = subj.total_question_cnt || 0;
                        questionCounts[subj.subject_superset_id] = count;

                        const easy = Math.floor(count / 3);
                        const medium = Math.floor(count / 3);
                        const tough = count - (easy + medium);
                        difficultyMap[subj.subject_superset_id] = {
                          firstSegment: easy,
                          secondSegment: medium,
                          calculatedValue: tough,
                        };
                        totalCount += count;

                        formSubjects.push({
                          subject_superset_id: subj.subject_superset_id,
                          easy,
                          medium,
                          tough,
                          special_inst: subj.ms_desc || "",
                          chapters: [],
                        });
                      });
                      setCheckedSubjects(checked);
                      setDifficultyDistributions(difficultyMap);
                      setTotalQuestionCount(totalCount);
                      setSubjects((prevSubjects) =>
                        prevSubjects.map((s) => ({
                          ...s,
                          questionCount: questionCounts[s.subject_id] || 0,
                        }))
                      );
                      setFormData((prev) => ({
                        ...prev,
                        subjects: formSubjects,
                      }));
                    }}
                    options={testSeriesOptions}
                    isRequired={false}
                    disabled={questionPaperType === 1 || readOnlyMode}
                  />
                </div>
                <div className="item4">
                  <FormInputs
                    label="Question Paper Name"
                    value={formData.ques_paper_name}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        ques_paper_name: e.target.value,
                      })
                    }
                    required
                    disabled={readOnlyMode}
                  />
                </div>
                <div className="item6">
                  <FormInputs
                    label="Due Date"
                    type="datetime-local"
                    value={formData.due_date}
                    onChange={(e) =>
                      setFormData({ ...formData, due_date: e.target.value })
                    }
                    required
                    disabled={readOnlyMode}
                  />
                </div>
                <div className="item9">
                  <DropDown
                    label="Apply Pattern"
                    setSelected={(selectedOption) => {
                      setSelectedPattern(selectedOption || null);
                      const selectedPatternObj = patternsData.find(
                        (pattern) => pattern.id === selectedOption
                      );
                      if (selectedPatternObj) {
                        const { subjects, details } = selectedPatternObj;
                        const newCheckedSubjects = {};
                        const newExpandedSubjects = {};
                        const newSelectedChapters = {};
                        const newSpecialInstructions = {};
                        const newDifficultyDistributions = {};
                        const newQuestionCounts = {};
                        const newFormSubjects = [];

                        let totalQuestions = 0;

                        subjects.forEach((subj) => {
                          const subjectId = subj.subject_id;
                          const easy = subj.easy || 0;
                          const medium = subj.medium || 0;
                          const tough = subj.tough || 0;
                          const total = easy + medium + tough;
                          
                          newCheckedSubjects[subjectId] = true;
                          newExpandedSubjects[subjectId] = false;

                          newSelectedChapters[subjectId] = subj.chapters.map(
                            (ch) => ch.chapter_id
                          );

                          newSpecialInstructions[subjectId] =
                            subj.special_inst || "";

                          newDifficultyDistributions[subjectId] = {
                            firstSegment: easy,
                            secondSegment: medium,
                            calculatedValue: tough,
                          };

                          newQuestionCounts[subjectId] = total;
                          totalQuestions += total;

                          newFormSubjects.push({
                            subject_superset_id: subjectId,
                            easy,
                            medium,
                            tough,
                            special_inst: subj.special_inst || "",
                            chapters: subj.chapters || [],
                          });

                          if (!chapterData[subjectId]) {
                            fetch(
                              `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${subjectId}`
                            )
                              .then((res) => res.json())
                              .then((data) => {
                                setChapterData((prev) => ({
                                  ...prev,
                                  [subjectId]: data,
                                }));
                              });
                          }
                        });

                        setCheckedSubjects(newCheckedSubjects);
                        setExpandedSubjects(newExpandedSubjects);
                        setSelectedChapters(newSelectedChapters);
                        setSpecialInstructions(newSpecialInstructions);
                        setDifficultyDistributions(newDifficultyDistributions);
                        setTotalQuestionCount(totalQuestions);
                        setSelectedSubjects(subjects);
                        setSubjects((prevSubjects) =>
                          prevSubjects.map((subj) => {
                            const patternSubj =
                              selectedPatternObj.subjects.find(
                                (ps) => ps.subject_id === subj.subject_id
                              );
                            const isUserModified =
                              manuallyUpdatedSubjects[subj.subject_id];
                            if (patternSubj && !isUserModified) {
                              const total =
                                (patternSubj.easy || 0) +
                                (patternSubj.medium || 0) +
                                (patternSubj.tough || 0);
                              return {
                                ...subj,
                                questionCount: total,
                              };
                            }

                            return subj;
                          })
                        );
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          total_questions: totalQuestions,
                          ques_paper_type: details.ques_paper_type || null,
                          subjects: newFormSubjects,
                        }));
                      }
                    }}
                    options={
                      patternsData.length > 0
                        ? patternsData
                        : [{ id: "", label: "No Patterns Available" }]
                    }
                    minheight="250px"
                    Height="auto"
                    OverFlow="auto"
                    disabled={readOnlyMode || !!selectedtestSeriesId}
                  />
                </div>
                <div className="item7-ques-paper-guideline-del">
                  <FormInputs
                    label="Description"
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                    disabled={readOnlyMode}
                    required
                  />
                </div>
                <div className="item7-ques-paper-guideline-del">
                  <label>Guideline</label>
                  <textarea
                    placeholder="Write your guidelines here..."
                    value={formData.guidelines} 
                    onChange={(e) =>
                      setFormData({ ...formData, guidelines: e.target.value })
                    }
                    disabled={readOnlyMode}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* SUBJECTS Section */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>SUBJECTS</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordion}>
            {isOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpen && (
          <div className="accordion-content">
            <div>
              <table className="table-tc-create-test" style={{ opacity: 0.8 }}>
                <thead>
                  <tr>
                    <td>Subject/Chapter</td>
                    <td>Ques Count</td>
                    <td>Difficulty Level</td>
                    <td>
                      Assign Creators
                      <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                    </td>
                    <td>Assign Reviewer</td>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(subjects) && subjects.length > 0 ? (
                    subjects.map((subject) => {
                      const isChecked =
                        checkedSubjects[subject.subject_id] || false;
                      return (
                        <React.Fragment key={subject.subject_id}>
                          <tr
                            style={{
                              height: "62px",
                              opacity: isChecked ? 1 : 0.8,
                              borderBottom: expandedSubjects[subject.subject_id]
                                ? ""
                                : "1px solid #d6d6d6",
                            }}
                          >
                            <td style={{ width: "12%" }}>
                              <input
                                type="checkbox"
                                disabled={!!selectedtestSeriesId}
                                className="delete-question-checkbox-dqc"
                                checked={isChecked}
                                onChange={() => {
                                  if (!readOnlyMode)
                                    handleSubjectCheck(subject.subject_id);
                                }}
                                style={{ opacity: 1 }}
                              />
                              <span
                                style={{
                                  marginRight: "6px",
                                  cursor: isChecked ? "pointer" : "not-allowed",
                                  fontWeight: "bold",
                                  opacity: isChecked ? 1 : 0.5,
                                }}
                                onClick={() => {
                                  if (!readOnlyMode)
                                    toggleExpandSubject(subject.subject_id);
                                }}
                              >
                                {(selectedChapters[subject.subject_id]
                                  ?.length || 0) === 0
                                  ? "+"
                                  : expandedSubjects[subject.subject_id]
                                  ? "−"
                                  : "+"}
                              </span>
                              {subject.subject_name}
                            </td>
                            <td style={{ width: "7%" }}>
                              <input
                                type="text"
                                className="input-details-nts-cr-test"
                                maxLength={3}
                                value={
                                  isChecked ? subject.questionCount || "" : ""
                                }
                                onChange={(e) =>
                                  handleQuestionCountChange(
                                    subject.subject_id,
                                    e.target.value
                                  )
                                }
                                style={{ opacity: isChecked ? 1 : 0.8 }}
                                readOnly={
                                  !isChecked ||
                                  readOnlyMode ||
                                  !!selectedtestSeriesId
                                }
                              />
                            </td>
                            <td style={{ width: "30%" }}>
                              <MultiProgress
                                total={
                                  isChecked
                                    ? parseInt(subject.questionCount, 10) || 0
                                    : 0
                                }
                                onSliderChange={(values) =>
                                  handleSliderChange(subject.subject_id, values)
                                }
                                defaultValues={
                                  difficultyDistributions[subject.subject_id]
                                }
                                isEnabled={!readOnlyMode}
                              />
                            </td>
                            <td style={{ width: "12%", verticalAlign: "top" }}>
                              <div className="input-wrapper-column">
                                <div className="input-wrapper-top">
                                  <FacultySelectorPreselected
                                    isMultiSelect={true}
                                    userId={userId}
                                    selectedSubjectId={subject.subject_id}
                                    isChecked={isChecked}
                                    selectedFacultiesProp={
                                      selectedCreatorsBySubject[
                                        subject.subject_id
                                      ] || []
                                    }
                                    onSelectionChange={(selectedFaculties) => {
                                      setSelectedCreatorsBySubject((prev) => ({
                                        ...prev,
                                        [subject.subject_id]: selectedFaculties,
                                      }));
                                    }}
                                    excludeUserIds={(
                                      selectedReviewersBySubject[
                                        subject.subject_id
                                      ] || []
                                    ).map((f) => f.user_id)}
                                    disabled={readOnlyMode}
                                  />
                                  <img
                                    src={NotesIcon}
                                    alt="Notes Icon"
                                    className="outside-icon-notes"
                                    onClick={() => {
                                      if (!readOnlyMode)
                                        toggleNotesInput(subject.subject_id);
                                    }}
                                    style={{
                                      cursor: readOnlyMode
                                        ? "not-allowed"
                                        : "pointer",
                                      opacity: readOnlyMode ? 0.5 : 1,
                                    }}
                                  />
                                </div>
                                {openNotes[subject.subject_id] && isChecked && (
                                  <input
                                    type="text"
                                    className="assign-notes-input"
                                    placeholder="Add a note..."
                                    value={
                                      specialInstructions[subject.subject_id] ||
                                      ""
                                    }
                                    onChange={(e) =>
                                      handleSpecialInstructionChange(
                                        subject.subject_id,
                                        e.target.value
                                      )
                                    }
                                    disabled={!isChecked || readOnlyMode}
                                  />
                                )}
                              </div>
                            </td>
                            <td style={{ width: "18%" }}>
                              <div
                                className="input-wrapper"
                                style={{
                                  opacity: isChecked ? 1 : 0.8,
                                  position: "relative",
                                }}
                              >
                                <FacultySelectorPreselected
                                  isMultiSelect={false}
                                  userId={userId}
                                  selectedSubjectId={subject.subject_id}
                                  isChecked={isChecked}
                                  selectedFacultiesProp={
                                    selectedReviewersBySubject[
                                      subject.subject_id
                                    ] || []
                                  }
                                  onSelectionChange={(selectedFaculties) => {
                                    setSelectedReviewersBySubject((prev) => ({
                                      ...prev,
                                      [subject.subject_id]: selectedFaculties,
                                    }));
                                  }}
                                  excludeUserIds={(
                                    selectedCreatorsBySubject[
                                      subject.subject_id
                                    ] || []
                                  ).map((f) => f.user_id)}
                                  disabled={readOnlyMode}
                                />
                              </div>
                            </td>
                          </tr>
                          {expandedSubjects[subject.subject_id] &&
                            isChecked && (
                              <tr
                                style={{ borderBottom: "1px solid  #d6d6d6" }}
                              >
                                <td colSpan="5">
                                  <div className="chapter-list-create-test">
                                    <ul>
                                      <li style={{ marginBottom: "14px" }}>
                                        <input
                                          type="checkbox"
                                          ref={(el) => {
                                            if (el) {
                                              const total =
                                                chapterData[subject.subject_id]
                                                  ?.length || 0;
                                              const selected =
                                                selectedChapters[
                                                  subject.subject_id
                                                ]?.length || 0;
                                              el.indeterminate =
                                                selected > 0 &&
                                                selected < total;
                                            }
                                          }}
                                          className={
                                            selectedChapters[subject.subject_id]
                                              ?.length ===
                                            chapterData[subject.subject_id]
                                              ?.length
                                              ? "delete-question-checkbox-dqc"
                                              : selectedChapters[
                                                  subject.subject_id
                                                ]?.length > 0
                                              ? "expend-chapt-sub-check-box indeterminate"
                                              : "expend-chapt-sub-check-box"
                                          }
                                          onChange={() =>
                                            handleSelectAllChapters(
                                              subject.subject_id
                                            )
                                          }
                                          checked={
                                            selectedChapters[subject.subject_id]
                                              ?.length ===
                                            chapterData[subject.subject_id]
                                              ?.length
                                          }
                                        />
                                        Chapters
                                      </li>
                                      {Array.isArray(
                                        chapterData[subject.subject_id]
                                      ) &&
                                      chapterData[subject.subject_id].length >
                                        0 ? (
                                        chapterData[subject.subject_id].map(
                                          (chapter) => (
                                            <li
                                              key={chapter.chapter_id}
                                              className="chapter-item-cr-ts"
                                            >
                                              <input
                                                type="checkbox"
                                                className="delete-question-checkbox-dqc"
                                                checked={
                                                  selectedChapters[
                                                    subject.subject_id
                                                  ]?.includes(
                                                    chapter.chapter_id
                                                  ) || false
                                                }
                                                onChange={() =>
                                                  handleChapterCheck(
                                                    subject.subject_id,
                                                    chapter.chapter_id
                                                  )
                                                }
                                              />
                                              {chapter.chapter_name}
                                            </li>
                                          )
                                        )
                                      ) : (
                                        <div className="chapter-details">
                                          No chapters available
                                        </div>
                                      )}
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                            )}
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="5" style={{ textAlign: "center" }}>
                        No subjects available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="total-question-count-cr-test">
              <span>Total Questions: </span> {totalQuestionCount}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CurateQuestionPaperEdit;